/* eslint-disable */
//@ts-nocheck
import {
  GraphQLResolveInfo,
  GraphQLScalarType,
  GraphQLScalarTypeConfig,
} from 'graphql';
import { IContext } from 'infra/graphql/context';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type RequireFields<T, K extends keyof T> = {
  [X in Exclude<keyof T, K>]?: T[X];
} &
  { [P in K]-?: NonNullable<T[P]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: any;
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  DateTime: any;
  /** A field whose value conforms to the standard internet email address format as specified in RFC822: https://www.w3.org/Protocols/rfc822/. */
  EmailAddress: any;
  /** A field whose value conforms to the standard URL format as specified in RFC3986: https://www.ietf.org/rfc/rfc3986.txt. */
  URL: any;
  /** A date string, such as 2007-12-03, compliant with the `full-date` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  Date: any;
  /** A time string at UTC, such as 10:15:30Z, compliant with the `full-time` format outlined in section 5.6 of the RFC 3339profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  Time: any;
};

export enum AccessAction {
  Revoke = 'REVOKE',
  Change = 'CHANGE',
}

export type AddSurfaceNodeToSurfaceProtocolNodeInput = {
  node: Scalars['ID'];
  protocolNode: Scalars['ID'];
};

export type ChangeUsersAccessOnSurfaceInput = {
  surface: Scalars['ID'];
  usersAccess: Array<UserAccessInput>;
};

export type CheckIfCodeIsUsedInput = {
  code: Scalars['String'];
};

export type CollaboratingUserCursorMovedOnSurfaceInput = {
  surface: Scalars['ID'];
  cursorPosition?: Maybe<PositionInput>;
};

export type CollaboratingUserEnteredSurfaceInput = {
  surface: Scalars['ID'];
  cursorPosition?: Maybe<PositionInput>;
};

export type CollaboratingUserLeftSurfaceInput = {
  surface: Scalars['ID'];
  cursorPosition?: Maybe<PositionInput>;
};

export type CopySurfaceNodeByReferenceInput = {
  id: Scalars['ID'];
  surface?: Maybe<Scalars['ID']>;
  position?: Maybe<PositionInput>;
};

export type CopySurfaceNodeInput = {
  id: Scalars['ID'];
  surface?: Maybe<Scalars['ID']>;
  position?: Maybe<PositionInput>;
};

export type CopySurfaceNodesByReferenceInput = {
  id: Scalars['ID'];
  surface?: Maybe<Scalars['ID']>;
  position?: Maybe<PositionInput>;
};

export type CopySurfaceNodesInput = {
  id: Scalars['ID'];
  surface?: Maybe<Scalars['ID']>;
  position?: Maybe<PositionInput>;
};

export type CreateSurfaceDocumentNodeInput = {
  surface: Scalars['ID'];
  name: Scalars['String'];
  position: SurfaceNodePositionInput;
  format: SurfaceDocumentNodeFormat;
  snippets?: Maybe<Array<Maybe<DocumentSnippetInput>>>;
  instantJSON?: Maybe<Scalars['JSON']>;
  mimeType?: Maybe<Scalars['String']>;
};

export type CreateSurfaceDocumentNodeSnippetInput = {
  nodeId: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  text: Scalars['String'];
  instantJSON?: Maybe<Scalars['JSON']>;
};

export type CreateSurfaceImageNodeInput = {
  surface: Scalars['ID'];
  name: Scalars['String'];
  url?: Maybe<Scalars['String']>;
  position: SurfaceNodePositionInput;
  format: SurfaceImageNodeFormat;
};

export type CreateSurfaceBackgroundNodeInput = {
  surface: Scalars['ID'];
  name: Scalars['String'];
  url?: Maybe<Scalars['String']>;
  position: SurfaceNodePositionInput;
  format: SurfaceImageNodeFormat;
};

export type CreateSurfaceInput = {
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  surface?: Maybe<Scalars['ID']>;
  position?: Maybe<SurfaceNodePositionInput>;
  questionnaire?: Maybe<Scalars['ID']>;
  rating?: Maybe<Scalars['Number']>;
  ratingComment?: Maybe<Scalars['String']>;
};

export type CreateSurfaceNodeFileReadUrlInput = {
  name: Scalars['String'];
};

export type CreateSurfaceNodeFileReadUrlResult = {
  __typename?: 'CreateSurfaceNodeFileReadUrlResult';
  url: Scalars['String'];
  bucketName: Scalars['String'];
  region: Scalars['String'];
};

export type CreateSurfaceNodeFileReadUrlResultPayload = {
  __typename?: 'CreateSurfaceNodeFileReadUrlResultPayload';
  data?: Maybe<CreateSurfaceNodeFileReadUrlResult>;
  error?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
  status?: Maybe<Scalars['Int']>;
};

export type CreateSurfaceNodeFileUploadUrlInput = {
  file: SurfaceNodeFileInput;
};

export type CreateSurfaceNodeFileUploadUrlResult = {
  __typename?: 'CreateSurfaceNodeFileUploadUrlResult';
  url: Scalars['String'];
  bucketName: Scalars['String'];
  region: Scalars['String'];
};

export type CreateSurfaceNodeFileUploadUrlResultPayload = {
  __typename?: 'CreateSurfaceNodeFileUploadUrlResultPayload';
  data?: Maybe<CreateSurfaceNodeFileUploadUrlResult>;
  error?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
  status?: Maybe<Scalars['Int']>;
};

export type CreateSurfaceNoteNodeInput = {
  surface: Scalars['ID'];
  name: Scalars['String'];
  text?: Maybe<Scalars['String']>;
  slateData?: Maybe<Scalars['JSON']>;
  snippets?: Maybe<Array<Maybe<TextSnippetInput>>>;
  position: SurfaceNodePositionInput;
};

export type CreateSurfaceProtocolNodeInput = {
  surface: Scalars['ID'];
  name: Scalars['String'];
  position: SurfaceNodePositionInput;
};

export type CreateSurfaceQuestionnaireNodeInput = {
  surface: Scalars['ID'];
  name: Scalars['String'];
  question: Scalars['String'];
  answerType: Scalars['String'];
  position: SurfaceNodePositionInput;
};

export type CreateSurfaceRisDocumentNodeInput = {
  surface: Scalars['ID'];
  name: Scalars['String'];
  position: SurfaceNodePositionInput;
  format: SurfaceDocumentNodeFormat;
  snippets?: Maybe<Array<Maybe<DocumentSnippetInput>>>;
  url: Scalars['URL'];
  instantJSON?: Maybe<Scalars['JSON']>;
};

export type CreateSurfaceTextNodeInput = {
  surface: Scalars['ID'];
  name: Scalars['String'];
  text?: Maybe<Scalars['String']>;
  slateData?: Maybe<Scalars['JSON']>;
  snippets?: Maybe<Array<Maybe<TextSnippetInput>>>;
  position: SurfaceNodePositionInput;
};

export type CreateSurfaceTextNodeSnippetInput = {
  nodeId: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  text: Scalars['String'];
  slateRepresentation?: Maybe<Scalars['JSON']>;
};

export type CursorPagination = {
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
};

export type CutSurfaceNodeInput = {
  id: Scalars['ID'];
  surface: Scalars['ID'];
  position?: Maybe<PositionInput>;
};

export type CutSurfaceNodesInput = {
  id: Scalars['ID'];
  surface: Scalars['ID'];
  position?: Maybe<PositionInput>;
};

export type DeleteSurfaceNodeRepsonse = {
  __typename?: 'DeleteSurfaceNodeRepsonse';
  deletedSurfaceNode: SurfaceNodeUnion;
  references: Array<Maybe<SurfaceNodeUnion>>;
};

export type DeleteSurfaceNodeRepsonsePayload = {
  __typename?: 'DeleteSurfaceNodeRepsonsePayload';
  data?: Maybe<DeleteSurfaceNodeRepsonse>;
  error?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
  status?: Maybe<Scalars['Int']>;
};

export type DeleteUserInvitationResponse = {
  __typename?: 'DeleteUserInvitationResponse';
  isSuccess: Scalars['Boolean'];
};

export type DeleteUserInvitationResponsePayload = {
  __typename?: 'DeleteUserInvitationResponsePayload';
  data?: Maybe<DeleteUserInvitationResponse>;
  error?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
  status?: Maybe<Scalars['Int']>;
};

export type DocumentSnippetInput = {
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  text: Scalars['String'];
  annotationId: Scalars['String'];
  operation?: Maybe<SnippetOperation>;
};

export type EjectSurfaceNodeFromSurfaceProtocolNodeInput = {
  node: Scalars['ID'];
  protocolNode: Scalars['ID'];
};

export type IntPayload = {
  __typename?: 'IntPayload';
  data?: Maybe<Scalars['Int']>;
  error?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
  status?: Maybe<Scalars['Int']>;
};

export type Invitation = {
  __typename?: 'Invitation';
  id: Scalars['ID'];
  email: Scalars['EmailAddress'];
  role: SurfaceRole;
};

export type InvitationWithRole = {
  __typename?: 'InvitationWithRole';
  invitation: Invitation;
  role: SurfaceRole;
};

export enum LineShape {
  Line = 'LINE',
  Arrow = 'ARROW',
  Circle = 'CIRCLE',
  Square = 'SQUARE',
}

export type LinkSurfaceNodesInput = {
  from: SurfaceNodeLinkInput;
  to: SurfaceNodeLinkInput;
};

export type LinkSurfaceNodesResult = {
  __typename?: 'LinkSurfaceNodesResult';
  fromNode: SurfaceNodeUnion;
  toNode: SurfaceNodeUnion;
};

export type LinkSurfaceNodesResultPayload = {
  __typename?: 'LinkSurfaceNodesResultPayload';
  data?: Maybe<LinkSurfaceNodesResult>;
  error?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
  status?: Maybe<Scalars['Int']>;
};

export enum LinkType {
  Full = 'FULL',
  Dashed = 'DASHED',
}

export type ListPayloadMeta = {
  __typename?: 'ListPayloadMeta';
  totalCount?: Maybe<Scalars['Int']>;
  count?: Maybe<Scalars['Int']>;
  totalPages?: Maybe<Scalars['Int']>;
  offset?: Maybe<OffsetPageInfo>;
};

export enum ListPayloadTypeEnum {
  Offset = 'OFFSET',
  Cursor = 'CURSOR',
}

export type MarkAllNotificationsAsSeenResponse = {
  __typename?: 'MarkAllNotificationsAsSeenResponse';
  isSuccess: Scalars['Boolean'];
};

export type MarkAllNotificationsAsSeenResponsePayload = {
  __typename?: 'MarkAllNotificationsAsSeenResponsePayload';
  data?: Maybe<MarkAllNotificationsAsSeenResponse>;
  error?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
  status?: Maybe<Scalars['Int']>;
};

export type MarkCodeAsUsedInput = {
  code: Scalars['String'];
  email: Scalars['String'];
};

export type Mutation = {
  __typename?: 'Mutation';
  _?: Maybe<Scalars['String']>;
  createSurface?: Maybe<SubSurfaceNodePayload>;
  linkSurfaceNodes?: Maybe<LinkSurfaceNodesResultPayload>;
  unLinkSurfaceNodes?: Maybe<UnLinkSurfaceNodesResultPayload>;
  updateSurfaceNodePosition?: Maybe<SurfaceNodeUnionPayload>;
  createSurfaceNodeFileUploadUrl?: Maybe<CreateSurfaceNodeFileUploadUrlResultPayload>;
  createSurfaceNodeFileReadUrl?: Maybe<CreateSurfaceNodeFileReadUrlResultPayload>;
  updateSurface?: Maybe<SubSurfaceNodePayload>;
  deleteSurfaceNode?: Maybe<DeleteSurfaceNodeRepsonsePayload>;
  softDeleteSurfaceNode?: Maybe<SoftDeleteSurfaceNodeRepsonsePayload>;
  createSurfaceTextNode?: Maybe<SurfaceNodeUnionPayload>;
  updateSurfaceTextNode?: Maybe<SurfaceNodeUnionPayload>;
  createSurfaceRisDocumentNode?: Maybe<SurfaceNodeUnionPayload>;
  createSurfaceDocumentNode?: Maybe<SurfaceNodeUnionPayload>;
  updateSurfaceDocumentNode?: Maybe<SurfaceNodeUnionPayload>;
  createSurfaceImageNode?: Maybe<SurfaceNodeUnionPayload>;
  updateSurfaceImageNode?: Maybe<SurfaceNodeUnionPayload>;
  createSurfaceNoteNode?: Maybe<SurfaceNodeUnionPayload>;
  updateSurfaceNoteNode?: Maybe<SurfaceNodeUnionPayload>;
  createSurfaceProtocolNode?: Maybe<SurfaceNodeUnionPayload>;
  updateSurfaceProtocolNode?: Maybe<SurfaceNodeUnionPayload>;
  addSurfaceNodeToSurfaceProtocolNode?: Maybe<SurfaceNodeUnionPayload>;
  ejectSurfaceNodeFromSurfaceProtocolNode?: Maybe<SurfaceNodeUnionPayload>;
  copySurfaceNode?: Maybe<SurfaceNodeUnionPayload>;
  copySurfaceNodes: Array<SurfaceNodeUnion>;
  cutSurfaceNode?: Maybe<SurfaceNodeUnionPayload>;
  cutSurfaceNodes: Array<SurfaceNodeUnion>;
  copySurfaceNodeByReference?: Maybe<SurfaceNodeUnionPayload>;
  copySurfaceNodesByReference: Array<SurfaceNodeUnion>;
  deleteSurfaceNodes: Array<DeleteSurfaceNodeRepsonse>;
  softDeleteSurfaceNodes: Array<SoftDeleteSurfaceNodeRepsonse>;
  createSurfaceDocumentNodeSnippet?: Maybe<SurfaceDocumentNodeSnippetPayload>;
  updateSurfaceDocumentNodeSnippet?: Maybe<SurfaceDocumentNodeSnippetPayload>;
  createSurfaceTextNodeSnippet?: Maybe<SurfaceTextNodeSnippetPayload>;
  updateSurfaceTextNodeSnippet?: Maybe<SurfaceTextNodeSnippetPayload>;
  updateSurfaceNodeLinkSettings?: Maybe<SurfaceNodeLinkSettingsPayload>;
  createSurfaceQuestionnaireNode?: Maybe<SurfaceNodeUnionPayload>;
  updateSurfaceQuestionnaireNode?: Maybe<SurfaceNodeUnionPayload>;
  collaboratingUserEnteredSurface?: Maybe<Scalars['Boolean']>;
  collaboratingUserLeftSurface?: Maybe<Scalars['Boolean']>;
  collaboratingUserCursorMovedOnSurface?: Maybe<Scalars['Boolean']>;
  surfaceNodeMovedOnSurface?: Maybe<Scalars['Boolean']>;
  updateUser?: Maybe<UserPayload>;
  shareSurfaceWithUsers?: Maybe<UserPayload>;
  changeUsersAccessOnSurface?: Maybe<UserPayload>;
  revokeUserAccessOnSurface?: Maybe<UserPayload>;
  deleteUserInvitation?: Maybe<DeleteUserInvitationResponsePayload>;
  markNotificationAsSeen?: Maybe<NotificationPayload>;
  markAllNotificationsAsSeen?: Maybe<MarkAllNotificationsAsSeenResponsePayload>;
  createSignInCode?: Maybe<SignInCodePayload>;
  markCodeAsUsed?: Maybe<SignInCodePayload>;
  checkIfCodeIsUsed?: Maybe<SignInCodePayload>;
};

export type MutationCreateSurfaceArgs = {
  input: CreateSurfaceInput;
};

export type MutationLinkSurfaceNodesArgs = {
  input: LinkSurfaceNodesInput;
};

export type MutationUnLinkSurfaceNodesArgs = {
  input: UnLinkSurfaceNodesInput;
};

export type MutationUpdateSurfaceNodePositionArgs = {
  input: UpdateSurfaceNodePositionInput;
};

export type MutationCreateSurfaceNodeFileUploadUrlArgs = {
  input: CreateSurfaceNodeFileUploadUrlInput;
};

export type MutationCreateSurfaceNodeFileReadUrlArgs = {
  input: CreateSurfaceNodeFileReadUrlInput;
};

export type MutationUpdateSurfaceArgs = {
  input: UpdateSurfaceInput;
};

export type MutationDeleteSurfaceNodeArgs = {
  id: Scalars['ID'];
};

export type MutationSoftDeleteSurfaceNodeArgs = {
  id: Scalars['ID'];
};

export type MutationCreateSurfaceTextNodeArgs = {
  input: CreateSurfaceTextNodeInput;
};

export type MutationUpdateSurfaceTextNodeArgs = {
  input: UpdateSurfaceTextNodeInput;
};

export type MutationCreateSurfaceRisDocumentNodeArgs = {
  input: CreateSurfaceRisDocumentNodeInput;
};

export type MutationCreateSurfaceDocumentNodeArgs = {
  input: CreateSurfaceDocumentNodeInput;
};

export type MutationUpdateSurfaceDocumentNodeArgs = {
  input: UpdateSurfaceDocumentNodeInput;
};

export type MutationCreateSurfaceImageNodeArgs = {
  input: CreateSurfaceImageNodeInput;
};

export type MutationUpdateSurfaceImageNodeArgs = {
  input: UpdateSurfaceImageNodeInput;
};

export type MutationCreateSurfaceNoteNodeArgs = {
  input: CreateSurfaceNoteNodeInput;
};

export type MutationUpdateSurfaceNoteNodeArgs = {
  input: UpdateSurfaceNoteNodeInput;
};

export type MutationCreateSurfaceProtocolNodeArgs = {
  input: CreateSurfaceProtocolNodeInput;
};

export type MutationUpdateSurfaceProtocolNodeArgs = {
  input: UpdateSurfaceProtocolNodeInput;
};

export type MutationAddSurfaceNodeToSurfaceProtocolNodeArgs = {
  input: AddSurfaceNodeToSurfaceProtocolNodeInput;
};

export type MutationEjectSurfaceNodeFromSurfaceProtocolNodeArgs = {
  input: EjectSurfaceNodeFromSurfaceProtocolNodeInput;
};

export type MutationCopySurfaceNodeArgs = {
  input: CopySurfaceNodeInput;
};

export type MutationCopySurfaceNodesArgs = {
  input: Array<CopySurfaceNodesInput>;
};

export type MutationCutSurfaceNodeArgs = {
  input: CutSurfaceNodeInput;
};

export type MutationCutSurfaceNodesArgs = {
  input: Array<CutSurfaceNodesInput>;
};

export type MutationCopySurfaceNodeByReferenceArgs = {
  input: CopySurfaceNodeByReferenceInput;
};

export type MutationCopySurfaceNodesByReferenceArgs = {
  input: Array<CopySurfaceNodesByReferenceInput>;
};

export type MutationDeleteSurfaceNodesArgs = {
  ids: Array<Scalars['ID']>;
};

export type MutationSoftDeleteSurfaceNodesArgs = {
  ids: Array<Scalars['ID']>;
};

export type MutationCreateSurfaceDocumentNodeSnippetArgs = {
  input: CreateSurfaceDocumentNodeSnippetInput;
};

export type MutationUpdateSurfaceDocumentNodeSnippetArgs = {
  input: UpdateSurfaceDocumentNodeSnippetInput;
};

export type MutationCreateSurfaceTextNodeSnippetArgs = {
  input: CreateSurfaceTextNodeSnippetInput;
};

export type MutationUpdateSurfaceTextNodeSnippetArgs = {
  input: UpdateSurfaceTextNodeSnippetInput;
};

export type MutationUpdateSurfaceNodeLinkSettingsArgs = {
  input: UpdateSurfaceNodeLinkSettingsInput;
};

export type MutationCreateSurfaceQuestionnaireNodeArgs = {
  input: CreateSurfaceQuestionnaireNodeInput;
};

export type MutationUpdateSurfaceQuestionnaireNodeArgs = {
  input: UpdateSurfaceQuestionnaireNodeInput;
};

export type MutationCollaboratingUserEnteredSurfaceArgs = {
  input: CollaboratingUserEnteredSurfaceInput;
};

export type MutationCollaboratingUserLeftSurfaceArgs = {
  input: CollaboratingUserLeftSurfaceInput;
};

export type MutationCollaboratingUserCursorMovedOnSurfaceArgs = {
  input: CollaboratingUserCursorMovedOnSurfaceInput;
};

export type MutationSurfaceNodeMovedOnSurfaceArgs = {
  input: SurfaceNodeMovedOnSurfaceInput;
};

export type MutationUpdateUserArgs = {
  input: UpdateUserInput;
};

export type MutationShareSurfaceWithUsersArgs = {
  input: ShareSurfaceWithUsersInput;
};

export type MutationChangeUsersAccessOnSurfaceArgs = {
  input: ChangeUsersAccessOnSurfaceInput;
};

export type MutationRevokeUserAccessOnSurfaceArgs = {
  input: RevokeUserAccessOnSurfaceInput;
};

export type MutationDeleteUserInvitationArgs = {
  id: Scalars['ID'];
};

export type MutationMarkNotificationAsSeenArgs = {
  id: Scalars['ID'];
};

export type MutationMarkCodeAsUsedArgs = {
  input: MarkCodeAsUsedInput;
};

export type MutationCheckIfCodeIsUsedArgs = {
  input: CheckIfCodeIsUsedInput;
};

export type Node = {
  id: Scalars['ID'];
};

export type Notification = {
  __typename?: 'Notification';
  id: Scalars['ID'];
  type: NotificationType;
  status: NotificationStatus;
  message?: Maybe<Scalars['String']>;
  sender: User;
  receiver: User;
  surface?: Maybe<SubSurfaceNode>;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
};

/** An edge in a connection. */
export type NotificationEdge = {
  __typename?: 'NotificationEdge';
  /** The item at the end of the edge */
  node?: Maybe<Notification>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

/** A connection to a list of items. */
export type NotificationListPayload = {
  __typename?: 'NotificationListPayload';
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<NotificationEdge>>>;
  meta?: Maybe<ListPayloadMeta>;
  error?: Maybe<Scalars['String']>;
  nodes?: Maybe<Array<Maybe<Notification>>>;
};

export type NotificationPayload = {
  __typename?: 'NotificationPayload';
  data?: Maybe<Notification>;
  error?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
  status?: Maybe<Scalars['Int']>;
};

export type NotificationsFilter = {
  type?: Maybe<NotificationType>;
  status?: Maybe<NotificationStatus>;
};

export type NotificationsInput = {
  filter?: Maybe<NotificationsFilter>;
  sort?: Maybe<Scalars['String']>;
  cursor?: Maybe<CursorPagination>;
  offset?: Maybe<OffsetPagination>;
};

export enum NotificationStatus {
  Seen = 'seen',
  Unseen = 'unseen',
}

export enum NotificationType {
  GrantAccess = 'grantAccess',
  RevokeAccess = 'revokeAccess',
  ChangeAccess = 'changeAccess',
}

export type OffsetPageInfo = {
  __typename?: 'OffsetPageInfo';
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
};

export type OffsetPagination = {
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
};

export type PageInfo = {
  __typename?: 'PageInfo';
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
  startCursor?: Maybe<Scalars['String']>;
  endCursor?: Maybe<Scalars['String']>;
};

export enum PaginationTypeEnum {
  Offset = 'OFFSET',
  Cursor = 'CURSOR',
}

export type Position = {
  __typename?: 'Position';
  x: Scalars['Float'];
  y: Scalars['Float'];
};

export type PositionInput = {
  x: Scalars['Float'];
  y: Scalars['Float'];
};

export type Query = {
  __typename?: 'Query';
  _?: Maybe<Scalars['String']>;
  surfaceHierarchy?: Maybe<SurfaceHierarchyPayload>;
  surfaces?: Maybe<SubSurfaceNodeListPayload>;
  surfaceNodes?: Maybe<SurfaceNodeUnionListPayload>;
  surfaceNode?: Maybe<SurfaceNodeUnionPayload>;
  risSearch?: Maybe<RisSearchItemListPayload>;
  isSurfaceShared?: Maybe<UndefinedPayload>;
  homeSurface?: Maybe<SubSurfaceNodePayload>;
  subSurfacesCount?: Maybe<IntPayload>;
  fetchLoggedUser?: Maybe<UserPayload>;
  fetchUsersWithAccessToSurface?: Maybe<UserAccessUnionListPayload>;
  notifications?: Maybe<NotificationListPayload>;
  signInCodes?: Maybe<SignInCodeListPayload>;
};

export type QuerySurfaceHierarchyArgs = {
  input: SurfaceHierarchyInput;
};

export type QuerySurfacesArgs = {
  input?: Maybe<SurfacesInput>;
};

export type QuerySurfaceNodesArgs = {
  input?: Maybe<SurfaceNodesInput>;
};

export type QuerySurfaceNodeArgs = {
  id: Scalars['ID'];
};

export type QueryRisSearchArgs = {
  input?: Maybe<RisSearchInput>;
};

export type QueryIsSurfaceSharedArgs = {
  id: Scalars['ID'];
};

export type QuerySubSurfacesCountArgs = {
  surface: Scalars['ID'];
};

export type QueryFetchUsersWithAccessToSurfaceArgs = {
  surface: Scalars['String'];
};

export type QueryNotificationsArgs = {
  input?: Maybe<NotificationsInput>;
};

export type QuerySignInCodesArgs = {
  input?: Maybe<SignInCodesInput>;
};

export type RevokeUserAccessOnSurfaceInput = {
  surface: Scalars['ID'];
  user: Scalars['ID'];
};

export type RisSearchFilter = {
  search: Scalars['String'];
  type: RisTypeSearch;
};

export type RisSearchInput = {
  filter: RisSearchFilter;
  sort?: Maybe<Scalars['String']>;
  cursor?: Maybe<CursorPagination>;
  offset?: Maybe<OffsetPagination>;
};

export type RisSearchItem = {
  __typename?: 'RisSearchItem';
  id?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  lawName?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  risUrl?: Maybe<Scalars['String']>;
};

/** An edge in a connection. */
export type RisSearchItemEdge = {
  __typename?: 'RisSearchItemEdge';
  /** The item at the end of the edge */
  node?: Maybe<RisSearchItem>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

/** A connection to a list of items. */
export type RisSearchItemListPayload = {
  __typename?: 'RisSearchItemListPayload';
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<RisSearchItemEdge>>>;
  meta?: Maybe<ListPayloadMeta>;
  error?: Maybe<Scalars['String']>;
  nodes?: Maybe<Array<Maybe<RisSearchItem>>>;
};

export enum RisTypeSearch {
  FederalLaw = 'FEDERAL_LAW',
  FederalStandards = 'FEDERAL_STANDARDS',
  Judicature = 'JUDICATURE',
}

export type ShareSurfaceWithUsersInput = {
  surface: Scalars['ID'];
  sharedWith: Array<ShareUserInput>;
  shareSubSurfaces?: Maybe<Scalars['Boolean']>;
};

export type ShareUserInput = {
  role: SurfaceRole;
  email: Scalars['EmailAddress'];
};

export type SignInCode = {
  __typename?: 'SignInCode';
  id: Scalars['ID'];
  code: Scalars['String'];
  usedOn?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
};

/** An edge in a connection. */
export type SignInCodeEdge = {
  __typename?: 'SignInCodeEdge';
  /** The item at the end of the edge */
  node?: Maybe<SignInCode>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

/** A connection to a list of items. */
export type SignInCodeListPayload = {
  __typename?: 'SignInCodeListPayload';
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<SignInCodeEdge>>>;
  meta?: Maybe<ListPayloadMeta>;
  error?: Maybe<Scalars['String']>;
  nodes?: Maybe<Array<Maybe<SignInCode>>>;
};

export type SignInCodePayload = {
  __typename?: 'SignInCodePayload';
  data?: Maybe<SignInCode>;
  error?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
  status?: Maybe<Scalars['Int']>;
};

export type SignInCodesFilter = {
  id?: Maybe<Scalars['ID']>;
};

export type SignInCodesInput = {
  filter?: Maybe<SignInCodesFilter>;
  sort?: Maybe<Scalars['String']>;
  cursor?: Maybe<CursorPagination>;
  offset?: Maybe<OffsetPagination>;
};

export enum SnippetOperation {
  Create = 'CREATE',
  Update = 'UPDATE',
  Delete = 'DELETE',
}

export type SoftDeleteSurfaceNodeRepsonse = {
  __typename?: 'SoftDeleteSurfaceNodeRepsonse';
  deletedSurfaceNode: SurfaceNodeUnion;
  references: Array<Maybe<SurfaceNodeUnion>>;
};

export type SoftDeleteSurfaceNodeRepsonsePayload = {
  __typename?: 'SoftDeleteSurfaceNodeRepsonsePayload';
  data?: Maybe<SoftDeleteSurfaceNodeRepsonse>;
  error?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
  status?: Maybe<Scalars['Int']>;
};

export type Subscription = {
  __typename?: 'Subscription';
  _?: Maybe<Scalars['String']>;
  surfaceNodeCreated?: Maybe<SurfaceNodeUnion>;
  surfaceNodeUpdated?: Maybe<SurfaceNodeUnion>;
  surfaceNodePositionUpdated?: Maybe<SurfaceNodeUnion>;
  surfaceNodeDeleted?: Maybe<SurfaceNodeUnion>;
  surfaceNodePasted?: Maybe<SurfaceNodeUnion>;
  surfaceNodesLinked?: Maybe<SurfaceNodeUnion>;
  surfaceNodesUnlinked?: Maybe<SurfaceNodeUnion>;
  collaboratingUserEnteredSurfaceSubscription?: Maybe<UserEnteredSurface>;
  collaboratingUserLeftSurfaceSubscription?: Maybe<UserLeftSurface>;
  collaboratingUserCursorMovedOnSurfaceSubscription?: Maybe<UserCurorMoved>;
  surfaceNodeShared?: Maybe<SubSurfaceNode>;
  surfaceNodeRevoked?: Maybe<SubSurfaceNode>;
  surfaceNodeMoved?: Maybe<SurfaceNodeMoved>;
  userNotificationCreated?: Maybe<Notification>;
};

export type SubscriptionSurfaceNodeCreatedArgs = {
  surface: Scalars['ID'];
};

export type SubscriptionSurfaceNodeUpdatedArgs = {
  surface: Scalars['ID'];
};

export type SubscriptionSurfaceNodePositionUpdatedArgs = {
  surface: Scalars['ID'];
};

export type SubscriptionSurfaceNodeDeletedArgs = {
  surface: Scalars['ID'];
};

export type SubscriptionSurfaceNodePastedArgs = {
  surface: Scalars['ID'];
};

export type SubscriptionSurfaceNodesLinkedArgs = {
  surface: Scalars['ID'];
};

export type SubscriptionSurfaceNodesUnlinkedArgs = {
  surface: Scalars['ID'];
};

export type SubscriptionCollaboratingUserEnteredSurfaceSubscriptionArgs = {
  surface: Scalars['ID'];
};

export type SubscriptionCollaboratingUserLeftSurfaceSubscriptionArgs = {
  surface: Scalars['ID'];
};

export type SubscriptionCollaboratingUserCursorMovedOnSurfaceSubscriptionArgs = {
  surface: Scalars['ID'];
};

export type SubscriptionSurfaceNodeSharedArgs = {
  sharedSurfacesRoot: Scalars['ID'];
};

export type SubscriptionSurfaceNodeRevokedArgs = {
  sharedSurfacesRoot: Scalars['ID'];
};

export type SubscriptionSurfaceNodeMovedArgs = {
  surface: Scalars['ID'];
};

export type SubscriptionUserNotificationCreatedArgs = {
  user: Scalars['ID'];
};

export type SubSurfaceNode = SurfaceNode & {
  __typename?: 'SubSurfaceNode';
  id: Scalars['ID'];
  surface?: Maybe<SubSurfaceNode>;
  owner?: Maybe<User>;
  name: Scalars['String'];
  loggedUserRole?: Maybe<Scalars['String']>;
  isShared: Scalars['Boolean'];
  sharedRootSurface?: Maybe<SubSurfaceNode>;
  slug: Scalars['String'];
  position?: Maybe<Position>;
  sharedSurfacesRoot: Scalars['Boolean'];
  mySurfacesRoot: Scalars['Boolean'];
  rootSurface: Scalars['Boolean'];
  pointsTo?: Maybe<Array<Maybe<SurfaceNodePointsTo>>>;
  originalNode?: Maybe<SurfaceNodeUnion>;
  isOriginal?: Maybe<Scalars['Boolean']>;
  isReference?: Maybe<Scalars['Boolean']>;
  isCopyInProgress?: Maybe<Scalars['Boolean']>;
  references?: Maybe<Array<Maybe<SurfaceNodeUnion>>>;
  subSurfaces?: Maybe<SubSurfaceNodeListPayload>;
  hasReferences?: Maybe<Scalars['Boolean']>;
  hasSubSurfaces?: Maybe<Scalars['Boolean']>;
  subSurfacesCount: Scalars['Int'];
  type: SurfaceNodeType;
  hierarchy: Array<Maybe<SubSurfaceNode>>;
  createdBy: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  ownedBy: Scalars['String'];
  isReferenceCopy?: Maybe<Scalars['Boolean']>;
  isLocked?: Maybe<Scalars['Boolean']>;
  lockedAt?: Maybe<Scalars['DateTime']>;
  fetchedAt?: Maybe<Scalars['DateTime']>;
  lockedBy?: Maybe<Scalars['String']>;
  risk?: Maybe<Scalars['String']>;
};

/** An edge in a connection. */
export type SubSurfaceNodeEdge = {
  __typename?: 'SubSurfaceNodeEdge';
  /** The item at the end of the edge */
  node?: Maybe<SubSurfaceNode>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

/** A connection to a list of items. */
export type SubSurfaceNodeListPayload = {
  __typename?: 'SubSurfaceNodeListPayload';
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<SubSurfaceNodeEdge>>>;
  meta?: Maybe<ListPayloadMeta>;
  error?: Maybe<Scalars['String']>;
  nodes?: Maybe<Array<Maybe<SubSurfaceNode>>>;
};

export type SubSurfaceNodePayload = {
  __typename?: 'SubSurfaceNodePayload';
  data?: Maybe<SubSurfaceNode>;
  error?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
  status?: Maybe<Scalars['Int']>;
};

export type Surface = {
  __typename?: 'Surface';
  id: Scalars['ID'];
  name: Scalars['String'];
  slug: Scalars['String'];
  nodes?: Maybe<Array<SurfaceNodeUnion>>;
  hierarchy: Array<Maybe<SubSurfaceNode>>;
};

export type SurfaceContainerNodeUnion =
  | SurfaceTextNode
  | SurfaceNoteNode
  | SurfaceDocumentNode;

export type SurfaceDocumentNode = SurfaceNode & {
  __typename?: 'SurfaceDocumentNode';
  id: Scalars['ID'];
  surface?: Maybe<SubSurfaceNode>;
  name: Scalars['String'];
  slug: Scalars['String'];
  format: SurfaceDocumentNodeFormat;
  url: Scalars['String'];
  snippets?: Maybe<Array<Maybe<SurfaceDocumentNodeSnippet>>>;
  instantJSON?: Maybe<Scalars['JSON']>;
  position?: Maybe<Position>;
  pointsTo?: Maybe<Array<Maybe<SurfaceNodePointsTo>>>;
  originalNode?: Maybe<SurfaceNodeUnion>;
  isOriginal?: Maybe<Scalars['Boolean']>;
  isReference?: Maybe<Scalars['Boolean']>;
  references?: Maybe<Array<Maybe<SurfaceNodeUnion>>>;
  hasReferences?: Maybe<Scalars['Boolean']>;
  type: SurfaceNodeType;
  fromRis?: Maybe<Scalars['Boolean']>;
  createdBy: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  ownedBy: Scalars['String'];
  isReferenceCopy?: Maybe<Scalars['Boolean']>;
  isLocked?: Maybe<Scalars['Boolean']>;
  lockedAt?: Maybe<Scalars['DateTime']>;
  fetchedAt?: Maybe<Scalars['DateTime']>;
  lockedBy?: Maybe<Scalars['String']>;
  mimeType?: Maybe<Scalars['String']>;
  risk?: Maybe<Scalars['String']>;
};

export enum SurfaceDocumentNodeFormat {
  Pdf = 'PDF',
  File = 'FILE',
}

export type SurfaceDocumentNodeSnippet = SurfaceNode & {
  __typename?: 'SurfaceDocumentNodeSnippet';
  id: Scalars['ID'];
  surface?: Maybe<SubSurfaceNode>;
  containerNode?: Maybe<SurfaceContainerNodeUnion>;
  name: Scalars['String'];
  slug: Scalars['String'];
  text?: Maybe<Scalars['String']>;
  annotationId: Scalars['String'];
  position?: Maybe<Position>;
  pointsTo?: Maybe<Array<Maybe<SurfaceNodePointsTo>>>;
  originalNode?: Maybe<SurfaceNodeUnion>;
  isOriginal?: Maybe<Scalars['Boolean']>;
  isReference?: Maybe<Scalars['Boolean']>;
  references?: Maybe<Array<Maybe<SurfaceNodeUnion>>>;
  hasReferences?: Maybe<Scalars['Boolean']>;
  type: SurfaceNodeType;
  fromRis?: Maybe<Scalars['Boolean']>;
  createdBy: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  ownedBy: Scalars['String'];
  isReferenceCopy?: Maybe<Scalars['Boolean']>;
  isLocked?: Maybe<Scalars['Boolean']>;
  lockedAt?: Maybe<Scalars['DateTime']>;
  fetchedAt?: Maybe<Scalars['DateTime']>;
  lockedBy?: Maybe<Scalars['String']>;
  risk?: Maybe<Scalars['String']>;
};

export type SurfaceDocumentNodeSnippetPayload = {
  __typename?: 'SurfaceDocumentNodeSnippetPayload';
  data?: Maybe<SurfaceDocumentNodeSnippet>;
  error?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
  status?: Maybe<Scalars['Int']>;
};

export type SurfaceHierarchyInput = {
  surface: Scalars['ID'];
};

export type SurfaceHierarchyPayload = {
  __typename?: 'SurfaceHierarchyPayload';
  data?: Maybe<Array<Maybe<SubSurfaceNode>>>;
  error?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
  status?: Maybe<Scalars['Int']>;
};

export type SurfaceImageNode = SurfaceNode & {
  __typename?: 'SurfaceImageNode';
  id: Scalars['ID'];
  surface?: Maybe<SubSurfaceNode>;
  name: Scalars['String'];
  slug: Scalars['String'];
  format: SurfaceImageNodeFormat;
  url: Scalars['String'];
  position?: Maybe<Position>;
  pointsTo?: Maybe<Array<Maybe<SurfaceNodePointsTo>>>;
  originalNode?: Maybe<SurfaceNodeUnion>;
  isOriginal?: Maybe<Scalars['Boolean']>;
  isReference?: Maybe<Scalars['Boolean']>;
  references?: Maybe<Array<Maybe<SurfaceNodeUnion>>>;
  hasReferences?: Maybe<Scalars['Boolean']>;
  type: SurfaceNodeType;
  createdBy: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  ownedBy: Scalars['String'];
  isReferenceCopy?: Maybe<Scalars['Boolean']>;
  isLocked?: Maybe<Scalars['Boolean']>;
  lockedAt?: Maybe<Scalars['DateTime']>;
  fetchedAt?: Maybe<Scalars['DateTime']>;
  lockedBy?: Maybe<Scalars['String']>;
  risk?: Maybe<Scalars['String']>;
};

export type SurfaceBackgroundNode = SurfaceNode & {
  __typename?: 'SurfaceBackgroundNode';
  id: Scalars['ID'];
  surface?: Maybe<SubSurfaceNode>;
  name: Scalars['String'];
  slug: Scalars['String'];
  format: SurfaceImageNodeFormat;
  url: Scalars['String'];
  position?: Maybe<Position>;
  pointsTo?: Maybe<Array<Maybe<SurfaceNodePointsTo>>>;
  originalNode?: Maybe<SurfaceNodeUnion>;
  isOriginal?: Maybe<Scalars['Boolean']>;
  isReference?: Maybe<Scalars['Boolean']>;
  references?: Maybe<Array<Maybe<SurfaceNodeUnion>>>;
  hasReferences?: Maybe<Scalars['Boolean']>;
  type: SurfaceNodeType;
  createdBy: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  ownedBy: Scalars['String'];
  isReferenceCopy?: Maybe<Scalars['Boolean']>;
  isLocked?: Maybe<Scalars['Boolean']>;
  lockedAt?: Maybe<Scalars['DateTime']>;
  fetchedAt?: Maybe<Scalars['DateTime']>;
  lockedBy?: Maybe<Scalars['String']>;
  isFixed?: Maybe<Scalars['Boolean']>;
  size?: Maybe<Size>;
  risk?: Maybe<Scalars['String']>;
};

export enum SurfaceImageNodeFormat {
  Jpg = 'JPG',
  Jpeg = 'JPEG',
  Png = 'PNG',
  File = 'FILE',
}

export type SurfaceNode = {
  id: Scalars['ID'];
  surface?: Maybe<SubSurfaceNode>;
  position?: Maybe<Position>;
  pointsTo?: Maybe<Array<Maybe<SurfaceNodePointsTo>>>;
  originalNode?: Maybe<SurfaceNodeUnion>;
  isOriginal?: Maybe<Scalars['Boolean']>;
  isReference?: Maybe<Scalars['Boolean']>;
  references?: Maybe<Array<Maybe<SurfaceNodeUnion>>>;
  hasReferences?: Maybe<Scalars['Boolean']>;
  type: SurfaceNodeType;
  createdBy: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  risk: Maybe<Scalars['String']>;
};

export type SurfaceNodeFileInput = {
  name: Scalars['String'];
  type: Scalars['String'];
};

export type SurfaceNodeLinkInput = {
  id: Scalars['ID'];
  position?: Maybe<SurfaceNodePointsToPosition>;
  surface?: Maybe<Scalars['ID']>;
};

export type SurfaceNodeLinkSettings = {
  __typename?: 'SurfaceNodeLinkSettings';
  color?: Maybe<Scalars['String']>;
  startShape?: Maybe<LineShape>;
  endShape?: Maybe<LineShape>;
  linkType?: Maybe<LinkType>;
  linkName?: Maybe<Scalars['String']>;
  createdBy?: Maybe<Scalars['ID']>;
  updatedBy?: Maybe<Scalars['ID']>;
  updatedAt?: Maybe<Scalars['String']>;
  ownedBy?: Maybe<Scalars['ID']>;
  isEditable?: Maybe<Scalars['Boolean']>;
  isVisible?: Maybe<Scalars['Boolean']>;
};

export type SurfaceNodeLinkSettingsInput = {
  color?: Maybe<Scalars['String']>;
  startShape?: Maybe<LineShape>;
  endShape?: Maybe<LineShape>;
  linkType?: Maybe<LinkType>;
  linkName?: Maybe<Scalars['String']>;
};

export type SurfaceNodeLinkSettingsPayload = {
  __typename?: 'SurfaceNodeLinkSettingsPayload';
  data?: Maybe<SurfaceNodeLinkSettings>;
  error?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
  status?: Maybe<Scalars['Int']>;
};

export type SurfaceNodeMoved = {
  __typename?: 'SurfaceNodeMoved';
  id: Scalars['ID'];
  position: Position;
  surface: Scalars['ID'];
  user: Scalars['ID'];
};

export type SurfaceNodeMovedOnSurfaceInput = {
  surface: Scalars['ID'];
  id: Scalars['ID'];
  position: PositionInput;
};

export type SurfaceNodePointsTo = {
  __typename?: 'SurfaceNodePointsTo';
  from: SurfaceNodeUnion;
  to: SurfaceNodeUnion;
  settings?: Maybe<SurfaceNodeLinkSettings>;
};

export enum SurfaceNodePointsToPosition {
  Top = 'TOP',
  Bottom = 'BOTTOM',
  Left = 'LEFT',
  Right = 'RIGHT',
}

export type SurfaceNodePositionInput = {
  x: Scalars['Float'];
  y: Scalars['Float'];
};

export type SurfaceNodesFilter = {
  surface: Scalars['ID'];
  type?: Maybe<SurfaceNodeType>;
  ids?: Maybe<Array<Scalars['ID']>>;
};

export type SurfaceNodesInput = {
  filter?: Maybe<SurfaceNodesFilter>;
  sort?: Maybe<Scalars['String']>;
  cursor?: Maybe<CursorPagination>;
  offset?: Maybe<OffsetPagination>;
};

export enum SurfaceNodeType {
  SubSurface = 'SUB_SURFACE',
  Document = 'DOCUMENT',
  Image = 'IMAGE',
  Background = 'BACKGROUND',
  Directory = 'DIRECTORY',
  Text = 'TEXT',
  Note = 'NOTE',
  Protocol = 'PROTOCOL',
  Questionnaire = 'QUESTIONNAIRE',
  DocumentSnippet = 'DOCUMENT_SNIPPET',
  TextSnippet = 'TEXT_SNIPPET',
  Form = 'FORM',
}

export type SurfaceNodeUnion =
  | SurfaceTextNode
  | SurfaceDocumentNode
  | SurfaceImageNode
  | SurfaceBackgroundNode
  | SurfaceNoteNode
  | SurfaceProtocolNode
  | SubSurfaceNode
  | SurfaceQuestionnaireNode
  | SurfaceTextNodeSnippet
  | SurfaceDocumentNodeSnippet;

/** An edge in a connection. */
export type SurfaceNodeUnionEdge = {
  __typename?: 'SurfaceNodeUnionEdge';
  /** The item at the end of the edge */
  node?: Maybe<SurfaceNodeUnion>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

/** A connection to a list of items. */
export type SurfaceNodeUnionListPayload = {
  __typename?: 'SurfaceNodeUnionListPayload';
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<SurfaceNodeUnionEdge>>>;
  meta?: Maybe<ListPayloadMeta>;
  error?: Maybe<Scalars['String']>;
  nodes?: Maybe<Array<Maybe<SurfaceNodeUnion>>>;
};

export type SurfaceNodeUnionPayload = {
  __typename?: 'SurfaceNodeUnionPayload';
  data?: Maybe<SurfaceNodeUnion>;
  error?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
  status?: Maybe<Scalars['Int']>;
};

export type SurfaceNoteNode = SurfaceNode & {
  __typename?: 'SurfaceNoteNode';
  id: Scalars['ID'];
  surface?: Maybe<SubSurfaceNode>;
  name: Scalars['String'];
  slug: Scalars['String'];
  text?: Maybe<Scalars['String']>;
  slateData?: Maybe<Scalars['JSON']>;
  snippets?: Maybe<Array<Maybe<SurfaceTextNodeSnippet>>>;
  position?: Maybe<Position>;
  pointsTo?: Maybe<Array<Maybe<SurfaceNodePointsTo>>>;
  originalNode?: Maybe<SurfaceNodeUnion>;
  isOriginal?: Maybe<Scalars['Boolean']>;
  isReference?: Maybe<Scalars['Boolean']>;
  references?: Maybe<Array<Maybe<SurfaceNodeUnion>>>;
  hasReferences?: Maybe<Scalars['Boolean']>;
  type: SurfaceNodeType;
  createdBy: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  ownedBy: Scalars['String'];
  isReferenceCopy?: Maybe<Scalars['Boolean']>;
  isLocked?: Maybe<Scalars['Boolean']>;
  lockedAt?: Maybe<Scalars['DateTime']>;
  fetchedAt?: Maybe<Scalars['DateTime']>;
  lockedBy?: Maybe<Scalars['String']>;
  risk?: Maybe<Scalars['String']>;
};

export type SurfaceProtocolContainingNodeUnion =
  | SurfaceTextNode
  | SurfaceDocumentNode
  | SurfaceImageNode
  | SurfaceNoteNode
  | SubSurfaceNode
  | SurfaceQuestionnaireNode
  | SurfaceTextNodeSnippet
  | SurfaceDocumentNodeSnippet;

export type SurfaceProtocolNode = SurfaceNode & {
  __typename?: 'SurfaceProtocolNode';
  id: Scalars['ID'];
  slug: Scalars['String'];
  surface?: Maybe<SubSurfaceNode>;
  name: Scalars['String'];
  type: SurfaceNodeType;
  position: Position;
  pointsTo?: Maybe<Array<Maybe<SurfaceNodePointsTo>>>;
  originalNode?: Maybe<SurfaceNodeUnion>;
  isOriginal?: Maybe<Scalars['Boolean']>;
  isReference?: Maybe<Scalars['Boolean']>;
  references?: Maybe<Array<Maybe<SurfaceNodeUnion>>>;
  hasReferences?: Maybe<Scalars['Boolean']>;
  contains?: Maybe<SurfaceProtocolContainingNodeUnion>;
  createdBy: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  ownedBy: Scalars['String'];
  isReferenceCopy?: Maybe<Scalars['Boolean']>;
  isLocked?: Maybe<Scalars['Boolean']>;
  lockedAt?: Maybe<Scalars['DateTime']>;
  fetchedAt?: Maybe<Scalars['DateTime']>;
  lockedBy?: Maybe<Scalars['String']>;
  uploader?: Maybe<Scalars['String']>;
  uploadComment?: Maybe<Scalars['String']>;
  risk?: Maybe<Scalars['String']>;
};

export type SurfaceQuestionnaireNode = SurfaceNode & {
  __typename?: 'SurfaceQuestionnaireNode';
  id: Scalars['ID'];
  surface?: Maybe<SubSurfaceNode>;
  name: Scalars['String'];
  slug: Scalars['String'];
  question: Scalars['String'];
  answerType: Scalars['String'];
  position?: Maybe<Position>;
  pointsTo?: Maybe<Array<Maybe<SurfaceNodePointsTo>>>;
  originalNode?: Maybe<SurfaceNodeUnion>;
  isOriginal?: Maybe<Scalars['Boolean']>;
  isReference?: Maybe<Scalars['Boolean']>;
  references?: Maybe<Array<Maybe<SurfaceNodeUnion>>>;
  hasReferences?: Maybe<Scalars['Boolean']>;
  type: SurfaceNodeType;
  createdBy: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  ownedBy: Scalars['String'];
  isReferenceCopy?: Maybe<Scalars['Boolean']>;
  isLocked?: Maybe<Scalars['Boolean']>;
  lockedAt?: Maybe<Scalars['DateTime']>;
  fetchedAt?: Maybe<Scalars['DateTime']>;
  lockedBy?: Maybe<Scalars['String']>;
  risk?: Maybe<Scalars['String']>;
};

export enum SurfaceRole {
  Owner = 'OWNER',
  Viewer = 'VIEWER',
  Admin = 'ADMIN',
  Editor = 'EDITOR',
  RestrictedViewer = 'RESTRICTED_VIEWER',
  Linker = 'LINKER',
  FilerLinker = 'FILER_LINKER',
  Filler = 'FILLER',
}

export type SurfacesInput = {
  sort?: Maybe<Scalars['String']>;
  cursor?: Maybe<CursorPagination>;
  offset?: Maybe<OffsetPagination>;
};

export type SurfaceTextNode = SurfaceNode & {
  __typename?: 'SurfaceTextNode';
  id: Scalars['ID'];
  surface?: Maybe<SubSurfaceNode>;
  name: Scalars['String'];
  slug: Scalars['String'];
  text?: Maybe<Scalars['String']>;
  slateData?: Maybe<Scalars['JSON']>;
  snippets?: Maybe<Array<Maybe<SurfaceTextNodeSnippet>>>;
  url: Scalars['String'];
  position?: Maybe<Position>;
  pointsTo?: Maybe<Array<Maybe<SurfaceNodePointsTo>>>;
  originalNode?: Maybe<SurfaceNodeUnion>;
  isOriginal?: Maybe<Scalars['Boolean']>;
  isReference?: Maybe<Scalars['Boolean']>;
  references?: Maybe<Array<Maybe<SurfaceNodeUnion>>>;
  hasReferences?: Maybe<Scalars['Boolean']>;
  type: SurfaceNodeType;
  createdBy: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  ownedBy: Scalars['String'];
  isReferenceCopy?: Maybe<Scalars['Boolean']>;
  isLocked?: Maybe<Scalars['Boolean']>;
  lockedAt?: Maybe<Scalars['DateTime']>;
  fetchedAt?: Maybe<Scalars['DateTime']>;
  lockedBy?: Maybe<Scalars['String']>;
  risk?: Maybe<Scalars['String']>;
};

export type SurfaceTextNodeSnippet = SurfaceNode & {
  __typename?: 'SurfaceTextNodeSnippet';
  id: Scalars['ID'];
  surface?: Maybe<SubSurfaceNode>;
  containerNode?: Maybe<SurfaceContainerNodeUnion>;
  name: Scalars['String'];
  slug: Scalars['String'];
  text?: Maybe<Scalars['String']>;
  annotationId: Scalars['String'];
  slateRepresentation?: Maybe<Scalars['JSON']>;
  position?: Maybe<Position>;
  pointsTo?: Maybe<Array<Maybe<SurfaceNodePointsTo>>>;
  originalNode?: Maybe<SurfaceNodeUnion>;
  isOriginal?: Maybe<Scalars['Boolean']>;
  isReference?: Maybe<Scalars['Boolean']>;
  references?: Maybe<Array<Maybe<SurfaceNodeUnion>>>;
  hasReferences?: Maybe<Scalars['Boolean']>;
  type: SurfaceNodeType;
  createdBy: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  ownedBy: Scalars['String'];
  isReferenceCopy?: Maybe<Scalars['Boolean']>;
  isLocked?: Maybe<Scalars['Boolean']>;
  lockedAt?: Maybe<Scalars['DateTime']>;
  fetchedAt?: Maybe<Scalars['DateTime']>;
  lockedBy?: Maybe<Scalars['String']>;
  risk?: Maybe<Scalars['String']>;
};

export type SurfaceTextNodeSnippetPayload = {
  __typename?: 'SurfaceTextNodeSnippetPayload';
  data?: Maybe<SurfaceTextNodeSnippet>;
  error?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
  status?: Maybe<Scalars['Int']>;
};

export type TextSnippetInput = {
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  text: Scalars['String'];
  annotationId: Scalars['String'];
  operation?: Maybe<SnippetOperation>;
};

export type UndefinedPayload = {
  __typename?: 'undefinedPayload';
  data: Scalars['Boolean'];
  error?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
  status?: Maybe<Scalars['Int']>;
};

export type UnLinkSurfaceNodesInput = {
  fromId: Scalars['ID'];
  toId: Scalars['ID'];
};

export type UnLinkSurfaceNodesResult = {
  __typename?: 'UnLinkSurfaceNodesResult';
  fromNodeId: Scalars['String'];
  toNodeId: Scalars['String'];
};

export type UnLinkSurfaceNodesResultPayload = {
  __typename?: 'UnLinkSurfaceNodesResultPayload';
  data?: Maybe<UnLinkSurfaceNodesResult>;
  error?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
  status?: Maybe<Scalars['Int']>;
};

export type UpdateSurfaceDocumentNodeInput = {
  id: Scalars['ID'];
  surface?: Maybe<Scalars['ID']>;
  url?: Maybe<Scalars['URL']>;
  name?: Maybe<Scalars['String']>;
  position?: Maybe<SurfaceNodePositionInput>;
  format?: Maybe<SurfaceDocumentNodeFormat>;
  instantJSON?: Maybe<Scalars['JSON']>;
  snippets?: Maybe<Array<Maybe<DocumentSnippetInput>>>;
};

export type UpdateSurfaceDocumentNodeSnippetInput = {
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  instantJSON?: Maybe<Scalars['JSON']>;
};

export type UpdateSurfaceImageNodeInput = {
  id: Scalars['ID'];
  surface?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  position?: Maybe<SurfaceNodePositionInput>;
  format?: Maybe<SurfaceImageNodeFormat>;
};

export type UpdateSurfaceBackgroundNodeInput = {
  id: Scalars['ID'];
  surface?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  position?: Maybe<SurfaceNodePositionInput>;
  format?: Maybe<SurfaceImageNodeFormat>;
};

export type UpdateSurfaceInput = {
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
};

export type UpdateSurfaceNodeLinkSettingsInput = {
  fromId: Scalars['ID'];
  toId: Scalars['ID'];
  settings?: Maybe<SurfaceNodeLinkSettingsInput>;
};

export type UpdateSurfaceNodePositionInput = {
  nodeId: Scalars['ID'];
  position: SurfaceNodePositionInput;
};

export type UpdateSurfaceNoteNodeInput = {
  id: Scalars['ID'];
  surface?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  slateData?: Maybe<Scalars['JSON']>;
  snippets?: Maybe<Array<Maybe<TextSnippetInput>>>;
  position?: Maybe<SurfaceNodePositionInput>;
};

export type UpdateSurfaceProtocolNodeInput = {
  id: Scalars['ID'];
  surface?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  position?: Maybe<SurfaceNodePositionInput>;
};

export type UpdateSurfaceQuestionnaireNodeInput = {
  id: Scalars['ID'];
  surface?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  question?: Maybe<Scalars['String']>;
  answerType?: Maybe<Scalars['String']>;
  position?: Maybe<SurfaceNodePositionInput>;
};

export type UpdateSurfaceTextNodeInput = {
  id: Scalars['ID'];
  surface?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  slateData?: Maybe<Scalars['JSON']>;
  snippets?: Maybe<Array<Maybe<TextSnippetInput>>>;
  position?: Maybe<SurfaceNodePositionInput>;
};

export type UpdateSurfaceTextNodeSnippetInput = {
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  slateRepresentation?: Maybe<Scalars['JSON']>;
};

export type UpdateUserInput = {
  id: Scalars['ID'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  email: Scalars['EmailAddress'];
};

export type User = {
  __typename?: 'User';
  id: Scalars['ID'];
  fullName?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  emailVerified?: Maybe<Scalars['Boolean']>;
  avatar?: Maybe<Scalars['String']>;
};

export type UserAccessInput = {
  action: AccessAction;
  role: SurfaceRole;
  user: Scalars['ID'];
};

export type UserAccessUnion = UserWithRole | InvitationWithRole;

/** An edge in a connection. */
export type UserAccessUnionEdge = {
  __typename?: 'UserAccessUnionEdge';
  /** The item at the end of the edge */
  node?: Maybe<UserAccessUnion>;
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
};

/** A connection to a list of items. */
export type UserAccessUnionListPayload = {
  __typename?: 'UserAccessUnionListPayload';
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<UserAccessUnionEdge>>>;
  meta?: Maybe<ListPayloadMeta>;
  error?: Maybe<Scalars['String']>;
  nodes?: Maybe<Array<Maybe<UserAccessUnion>>>;
};

export type UserCurorMoved = {
  __typename?: 'UserCurorMoved';
  user?: Maybe<User>;
  cursorPosition?: Maybe<Position>;
  surface?: Maybe<Scalars['ID']>;
  color?: Maybe<Scalars['String']>;
};

export type UserEnteredSurface = {
  __typename?: 'UserEnteredSurface';
  user?: Maybe<User>;
  cursorPosition?: Maybe<Position>;
  surface: Scalars['ID'];
  color?: Maybe<Scalars['String']>;
};

export type UserLeftSurface = {
  __typename?: 'UserLeftSurface';
  user?: Maybe<User>;
  cursorPosition?: Maybe<Position>;
  surface: Scalars['ID'];
};

export type UserPayload = {
  __typename?: 'UserPayload';
  data?: Maybe<User>;
  error?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
  status?: Maybe<Scalars['Int']>;
};

export type UserWithRole = {
  __typename?: 'UserWithRole';
  user: User;
  role: SurfaceRole;
};

export type ResolverTypeWrapper<T> = Promise<T> | T;

export type LegacyStitchingResolver<TResult, TParent, TContext, TArgs> = {
  fragment: string;
  resolve: ResolverFn<TResult, TParent, TContext, TArgs>;
};

export type NewStitchingResolver<TResult, TParent, TContext, TArgs> = {
  selectionSet: string;
  resolve: ResolverFn<TResult, TParent, TContext, TArgs>;
};
export type StitchingResolver<TResult, TParent, TContext, TArgs> =
  | LegacyStitchingResolver<TResult, TParent, TContext, TArgs>
  | NewStitchingResolver<TResult, TParent, TContext, TArgs>;
export type Resolver<TResult, TParent = {}, TContext = {}, TArgs = {}> =
  | ResolverFn<TResult, TParent, TContext, TArgs>
  | StitchingResolver<TResult, TParent, TContext, TArgs>;

export type ResolverFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo,
) => Promise<TResult> | TResult;

export type SubscriptionSubscribeFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo,
) => AsyncIterator<TResult> | Promise<AsyncIterator<TResult>>;

export type SubscriptionResolveFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo,
) => TResult | Promise<TResult>;

export interface SubscriptionSubscriberObject<
  TResult,
  TKey extends string,
  TParent,
  TContext,
  TArgs
> {
  subscribe: SubscriptionSubscribeFn<
    { [key in TKey]: TResult },
    TParent,
    TContext,
    TArgs
  >;
  resolve?: SubscriptionResolveFn<
    TResult,
    { [key in TKey]: TResult },
    TContext,
    TArgs
  >;
}

export interface SubscriptionResolverObject<TResult, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<any, TParent, TContext, TArgs>;
  resolve: SubscriptionResolveFn<TResult, any, TContext, TArgs>;
}

export type SubscriptionObject<
  TResult,
  TKey extends string,
  TParent,
  TContext,
  TArgs
> =
  | SubscriptionSubscriberObject<TResult, TKey, TParent, TContext, TArgs>
  | SubscriptionResolverObject<TResult, TParent, TContext, TArgs>;

export type SubscriptionResolver<
  TResult,
  TKey extends string,
  TParent = {},
  TContext = {},
  TArgs = {}
> =
  | ((
      ...args: any[]
    ) => SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>)
  | SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>;

export type TypeResolveFn<TTypes, TParent = {}, TContext = {}> = (
  parent: TParent,
  context: TContext,
  info: GraphQLResolveInfo,
) => Maybe<TTypes> | Promise<Maybe<TTypes>>;

export type IsTypeOfResolverFn<T = {}, TContext = {}> = (
  obj: T,
  context: TContext,
  info: GraphQLResolveInfo,
) => boolean | Promise<boolean>;

export type NextResolverFn<T> = () => Promise<T>;

export type DirectiveResolverFn<
  TResult = {},
  TParent = {},
  TContext = {},
  TArgs = {}
> = (
  next: NextResolverFn<TResult>,
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo,
) => TResult | Promise<TResult>;

/** Mapping between all available schema types and the resolvers types */
export type ResolversTypes = {
  Query: ResolverTypeWrapper<{}>;
  String: ResolverTypeWrapper<Scalars['String']>;
  SurfaceHierarchyInput: SurfaceHierarchyInput;
  ID: ResolverTypeWrapper<Scalars['ID']>;
  SurfaceHierarchyPayload: ResolverTypeWrapper<SurfaceHierarchyPayload>;
  SubSurfaceNode: ResolverTypeWrapper<
    Omit<SubSurfaceNode, 'originalNode' | 'references'> & {
      originalNode?: Maybe<ResolversTypes['SurfaceNodeUnion']>;
      references?: Maybe<Array<Maybe<ResolversTypes['SurfaceNodeUnion']>>>;
    }
  >;
  SurfaceNode:
    | ResolversTypes['SubSurfaceNode']
    | ResolversTypes['SurfaceTextNode']
    | ResolversTypes['SurfaceTextNodeSnippet']
    | ResolversTypes['SurfaceNoteNode']
    | ResolversTypes['SurfaceDocumentNode']
    | ResolversTypes['SurfaceDocumentNodeSnippet']
    | ResolversTypes['SurfaceImageNode']
    | ResolversTypes['SurfaceProtocolNode']
    | ResolversTypes['SurfaceQuestionnaireNode'];
  Position: ResolverTypeWrapper<Position>;
  Float: ResolverTypeWrapper<Scalars['Float']>;
  SurfaceNodePointsTo: ResolverTypeWrapper<
    Omit<SurfaceNodePointsTo, 'from' | 'to'> & {
      from: ResolversTypes['SurfaceNodeUnion'];
      to: ResolversTypes['SurfaceNodeUnion'];
    }
  >;
  SurfaceNodeUnion:
    | ResolversTypes['SurfaceTextNode']
    | ResolversTypes['SurfaceDocumentNode']
    | ResolversTypes['SurfaceImageNode']
    | ResolversTypes['SurfaceBackgroundNode']
    | ResolversTypes['SurfaceNoteNode']
    | ResolversTypes['SurfaceProtocolNode']
    | ResolversTypes['SubSurfaceNode']
    | ResolversTypes['SurfaceQuestionnaireNode']
    | ResolversTypes['SurfaceTextNodeSnippet']
    | ResolversTypes['SurfaceDocumentNodeSnippet'];
  SurfaceTextNode: ResolverTypeWrapper<
    Omit<SurfaceTextNode, 'originalNode' | 'references'> & {
      originalNode?: Maybe<ResolversTypes['SurfaceNodeUnion']>;
      references?: Maybe<Array<Maybe<ResolversTypes['SurfaceNodeUnion']>>>;
    }
  >;
  JSON: ResolverTypeWrapper<Scalars['JSON']>;
  SurfaceTextNodeSnippet: ResolverTypeWrapper<
    Omit<
      SurfaceTextNodeSnippet,
      'containerNode' | 'originalNode' | 'references'
    > & {
      containerNode?: Maybe<ResolversTypes['SurfaceContainerNodeUnion']>;
      originalNode?: Maybe<ResolversTypes['SurfaceNodeUnion']>;
      references?: Maybe<Array<Maybe<ResolversTypes['SurfaceNodeUnion']>>>;
    }
  >;
  SurfaceContainerNodeUnion:
    | ResolversTypes['SurfaceTextNode']
    | ResolversTypes['SurfaceNoteNode']
    | ResolversTypes['SurfaceDocumentNode'];
  SurfaceNoteNode: ResolverTypeWrapper<
    Omit<SurfaceNoteNode, 'originalNode' | 'references'> & {
      originalNode?: Maybe<ResolversTypes['SurfaceNodeUnion']>;
      references?: Maybe<Array<Maybe<ResolversTypes['SurfaceNodeUnion']>>>;
    }
  >;
  Boolean: ResolverTypeWrapper<Scalars['Boolean']>;
  SurfaceNodeType: SurfaceNodeType;
  DateTime: ResolverTypeWrapper<Scalars['DateTime']>;
  SurfaceDocumentNode: ResolverTypeWrapper<
    Omit<SurfaceDocumentNode, 'originalNode' | 'references'> & {
      originalNode?: Maybe<ResolversTypes['SurfaceNodeUnion']>;
      references?: Maybe<Array<Maybe<ResolversTypes['SurfaceNodeUnion']>>>;
    }
  >;
  SurfaceDocumentNodeFormat: SurfaceDocumentNodeFormat;
  SurfaceDocumentNodeSnippet: ResolverTypeWrapper<
    Omit<
      SurfaceDocumentNodeSnippet,
      'containerNode' | 'originalNode' | 'references'
    > & {
      containerNode?: Maybe<ResolversTypes['SurfaceContainerNodeUnion']>;
      originalNode?: Maybe<ResolversTypes['SurfaceNodeUnion']>;
      references?: Maybe<Array<Maybe<ResolversTypes['SurfaceNodeUnion']>>>;
    }
  >;
  SurfaceImageNode: ResolverTypeWrapper<
    Omit<SurfaceImageNode, 'originalNode' | 'references'> & {
      originalNode?: Maybe<ResolversTypes['SurfaceNodeUnion']>;
      references?: Maybe<Array<Maybe<ResolversTypes['SurfaceNodeUnion']>>>;
    }
  >;
  SurfaceBackgroundNode: ResolverTypeWrapper<
    Omit<SurfaceBackgroundNode, 'originalNode' | 'references'> & {
      originalNode?: Maybe<ResolversTypes['SurfaceNodeUnion']>;
      references?: Maybe<Array<Maybe<ResolversTypes['SurfaceNodeUnion']>>>;
    }
  >;
  SurfaceImageNodeFormat: SurfaceImageNodeFormat;
  SurfaceProtocolNode: ResolverTypeWrapper<
    Omit<SurfaceProtocolNode, 'originalNode' | 'references' | 'contains'> & {
      originalNode?: Maybe<ResolversTypes['SurfaceNodeUnion']>;
      references?: Maybe<Array<Maybe<ResolversTypes['SurfaceNodeUnion']>>>;
      contains?: Maybe<ResolversTypes['SurfaceProtocolContainingNodeUnion']>;
    }
  >;
  SurfaceProtocolContainingNodeUnion:
    | ResolversTypes['SurfaceTextNode']
    | ResolversTypes['SurfaceDocumentNode']
    | ResolversTypes['SurfaceImageNode']
    | ResolversTypes['SurfaceBackgroundNode']
    | ResolversTypes['SurfaceNoteNode']
    | ResolversTypes['SubSurfaceNode']
    | ResolversTypes['SurfaceQuestionnaireNode']
    | ResolversTypes['SurfaceTextNodeSnippet']
    | ResolversTypes['SurfaceDocumentNodeSnippet'];
  SurfaceQuestionnaireNode: ResolverTypeWrapper<
    Omit<SurfaceQuestionnaireNode, 'originalNode' | 'references'> & {
      originalNode?: Maybe<ResolversTypes['SurfaceNodeUnion']>;
      references?: Maybe<Array<Maybe<ResolversTypes['SurfaceNodeUnion']>>>;
    }
  >;
  SurfaceNodeLinkSettings: ResolverTypeWrapper<SurfaceNodeLinkSettings>;
  LineShape: LineShape;
  LinkType: LinkType;
  User: ResolverTypeWrapper<User>;
  SubSurfaceNodeListPayload: ResolverTypeWrapper<SubSurfaceNodeListPayload>;
  PageInfo: ResolverTypeWrapper<PageInfo>;
  SubSurfaceNodeEdge: ResolverTypeWrapper<SubSurfaceNodeEdge>;
  ListPayloadMeta: ResolverTypeWrapper<ListPayloadMeta>;
  Int: ResolverTypeWrapper<Scalars['Int']>;
  OffsetPageInfo: ResolverTypeWrapper<OffsetPageInfo>;
  SurfacesInput: SurfacesInput;
  CursorPagination: CursorPagination;
  OffsetPagination: OffsetPagination;
  SurfaceNodesInput: SurfaceNodesInput;
  SurfaceNodesFilter: SurfaceNodesFilter;
  SurfaceNodeUnionListPayload: ResolverTypeWrapper<
    Omit<SurfaceNodeUnionListPayload, 'nodes'> & {
      nodes?: Maybe<Array<Maybe<ResolversTypes['SurfaceNodeUnion']>>>;
    }
  >;
  SurfaceNodeUnionEdge: ResolverTypeWrapper<
    Omit<SurfaceNodeUnionEdge, 'node'> & {
      node?: Maybe<ResolversTypes['SurfaceNodeUnion']>;
    }
  >;
  SurfaceNodeUnionPayload: ResolverTypeWrapper<
    Omit<SurfaceNodeUnionPayload, 'data'> & {
      data?: Maybe<ResolversTypes['SurfaceNodeUnion']>;
    }
  >;
  RisSearchInput: RisSearchInput;
  RisSearchFilter: RisSearchFilter;
  RisTypeSearch: RisTypeSearch;
  RisSearchItemListPayload: ResolverTypeWrapper<RisSearchItemListPayload>;
  RisSearchItemEdge: ResolverTypeWrapper<RisSearchItemEdge>;
  RisSearchItem: ResolverTypeWrapper<RisSearchItem>;
  undefinedPayload: ResolverTypeWrapper<UndefinedPayload>;
  SubSurfaceNodePayload: ResolverTypeWrapper<SubSurfaceNodePayload>;
  IntPayload: ResolverTypeWrapper<IntPayload>;
  UserPayload: ResolverTypeWrapper<UserPayload>;
  UserAccessUnionListPayload: ResolverTypeWrapper<
    Omit<UserAccessUnionListPayload, 'nodes'> & {
      nodes?: Maybe<Array<Maybe<ResolversTypes['UserAccessUnion']>>>;
    }
  >;
  UserAccessUnionEdge: ResolverTypeWrapper<
    Omit<UserAccessUnionEdge, 'node'> & {
      node?: Maybe<ResolversTypes['UserAccessUnion']>;
    }
  >;
  UserAccessUnion:
    | ResolversTypes['UserWithRole']
    | ResolversTypes['InvitationWithRole'];
  UserWithRole: ResolverTypeWrapper<UserWithRole>;
  SurfaceRole: SurfaceRole;
  InvitationWithRole: ResolverTypeWrapper<InvitationWithRole>;
  Invitation: ResolverTypeWrapper<Invitation>;
  EmailAddress: ResolverTypeWrapper<Scalars['EmailAddress']>;
  NotificationsInput: NotificationsInput;
  NotificationsFilter: NotificationsFilter;
  NotificationType: NotificationType;
  NotificationStatus: NotificationStatus;
  NotificationListPayload: ResolverTypeWrapper<NotificationListPayload>;
  NotificationEdge: ResolverTypeWrapper<NotificationEdge>;
  Notification: ResolverTypeWrapper<Notification>;
  SignInCodesInput: SignInCodesInput;
  SignInCodesFilter: SignInCodesFilter;
  SignInCodeListPayload: ResolverTypeWrapper<SignInCodeListPayload>;
  SignInCodeEdge: ResolverTypeWrapper<SignInCodeEdge>;
  SignInCode: ResolverTypeWrapper<SignInCode>;
  Mutation: ResolverTypeWrapper<{}>;
  CreateSurfaceInput: CreateSurfaceInput;
  SurfaceNodePositionInput: SurfaceNodePositionInput;
  LinkSurfaceNodesInput: LinkSurfaceNodesInput;
  SurfaceNodeLinkInput: SurfaceNodeLinkInput;
  SurfaceNodePointsToPosition: SurfaceNodePointsToPosition;
  LinkSurfaceNodesResultPayload: ResolverTypeWrapper<LinkSurfaceNodesResultPayload>;
  LinkSurfaceNodesResult: ResolverTypeWrapper<
    Omit<LinkSurfaceNodesResult, 'fromNode' | 'toNode'> & {
      fromNode: ResolversTypes['SurfaceNodeUnion'];
      toNode: ResolversTypes['SurfaceNodeUnion'];
    }
  >;
  UnLinkSurfaceNodesInput: UnLinkSurfaceNodesInput;
  UnLinkSurfaceNodesResultPayload: ResolverTypeWrapper<UnLinkSurfaceNodesResultPayload>;
  UnLinkSurfaceNodesResult: ResolverTypeWrapper<UnLinkSurfaceNodesResult>;
  UpdateSurfaceNodePositionInput: UpdateSurfaceNodePositionInput;
  CreateSurfaceNodeFileUploadUrlInput: CreateSurfaceNodeFileUploadUrlInput;
  SurfaceNodeFileInput: SurfaceNodeFileInput;
  CreateSurfaceNodeFileUploadUrlResultPayload: ResolverTypeWrapper<CreateSurfaceNodeFileUploadUrlResultPayload>;
  CreateSurfaceNodeFileUploadUrlResult: ResolverTypeWrapper<CreateSurfaceNodeFileUploadUrlResult>;
  CreateSurfaceNodeFileReadUrlInput: CreateSurfaceNodeFileReadUrlInput;
  CreateSurfaceNodeFileReadUrlResultPayload: ResolverTypeWrapper<CreateSurfaceNodeFileReadUrlResultPayload>;
  CreateSurfaceNodeFileReadUrlResult: ResolverTypeWrapper<CreateSurfaceNodeFileReadUrlResult>;
  UpdateSurfaceInput: UpdateSurfaceInput;
  DeleteSurfaceNodeRepsonsePayload: ResolverTypeWrapper<DeleteSurfaceNodeRepsonsePayload>;
  DeleteSurfaceNodeRepsonse: ResolverTypeWrapper<
    Omit<DeleteSurfaceNodeRepsonse, 'deletedSurfaceNode' | 'references'> & {
      deletedSurfaceNode: ResolversTypes['SurfaceNodeUnion'];
      references: Array<Maybe<ResolversTypes['SurfaceNodeUnion']>>;
    }
  >;
  SoftDeleteSurfaceNodeRepsonsePayload: ResolverTypeWrapper<SoftDeleteSurfaceNodeRepsonsePayload>;
  SoftDeleteSurfaceNodeRepsonse: ResolverTypeWrapper<
    Omit<SoftDeleteSurfaceNodeRepsonse, 'deletedSurfaceNode' | 'references'> & {
      deletedSurfaceNode: ResolversTypes['SurfaceNodeUnion'];
      references: Array<Maybe<ResolversTypes['SurfaceNodeUnion']>>;
    }
  >;
  CreateSurfaceTextNodeInput: CreateSurfaceTextNodeInput;
  TextSnippetInput: TextSnippetInput;
  SnippetOperation: SnippetOperation;
  UpdateSurfaceTextNodeInput: UpdateSurfaceTextNodeInput;
  CreateSurfaceRisDocumentNodeInput: CreateSurfaceRisDocumentNodeInput;
  DocumentSnippetInput: DocumentSnippetInput;
  URL: ResolverTypeWrapper<Scalars['URL']>;
  CreateSurfaceDocumentNodeInput: CreateSurfaceDocumentNodeInput;
  UpdateSurfaceDocumentNodeInput: UpdateSurfaceDocumentNodeInput;
  CreateSurfaceImageNodeInput: CreateSurfaceImageNodeInput;
  UpdateSurfaceImageNodeInput: UpdateSurfaceImageNodeInput;
  CreateSurfaceBackgroundNodeInput: CreateSurfaceBackgroundNodeInput;
  UpdateSurfaceBackgroundNodeInput: UpdateSurfaceBackgroundNodeInput;
  CreateSurfaceNoteNodeInput: CreateSurfaceNoteNodeInput;
  UpdateSurfaceNoteNodeInput: UpdateSurfaceNoteNodeInput;
  CreateSurfaceProtocolNodeInput: CreateSurfaceProtocolNodeInput;
  UpdateSurfaceProtocolNodeInput: UpdateSurfaceProtocolNodeInput;
  AddSurfaceNodeToSurfaceProtocolNodeInput: AddSurfaceNodeToSurfaceProtocolNodeInput;
  EjectSurfaceNodeFromSurfaceProtocolNodeInput: EjectSurfaceNodeFromSurfaceProtocolNodeInput;
  CopySurfaceNodeInput: CopySurfaceNodeInput;
  PositionInput: PositionInput;
  CopySurfaceNodesInput: CopySurfaceNodesInput;
  CutSurfaceNodeInput: CutSurfaceNodeInput;
  CutSurfaceNodesInput: CutSurfaceNodesInput;
  CopySurfaceNodeByReferenceInput: CopySurfaceNodeByReferenceInput;
  CopySurfaceNodesByReferenceInput: CopySurfaceNodesByReferenceInput;
  CreateSurfaceDocumentNodeSnippetInput: CreateSurfaceDocumentNodeSnippetInput;
  SurfaceDocumentNodeSnippetPayload: ResolverTypeWrapper<SurfaceDocumentNodeSnippetPayload>;
  UpdateSurfaceDocumentNodeSnippetInput: UpdateSurfaceDocumentNodeSnippetInput;
  CreateSurfaceTextNodeSnippetInput: CreateSurfaceTextNodeSnippetInput;
  SurfaceTextNodeSnippetPayload: ResolverTypeWrapper<SurfaceTextNodeSnippetPayload>;
  UpdateSurfaceTextNodeSnippetInput: UpdateSurfaceTextNodeSnippetInput;
  UpdateSurfaceNodeLinkSettingsInput: UpdateSurfaceNodeLinkSettingsInput;
  SurfaceNodeLinkSettingsInput: SurfaceNodeLinkSettingsInput;
  SurfaceNodeLinkSettingsPayload: ResolverTypeWrapper<SurfaceNodeLinkSettingsPayload>;
  CreateSurfaceQuestionnaireNodeInput: CreateSurfaceQuestionnaireNodeInput;
  UpdateSurfaceQuestionnaireNodeInput: UpdateSurfaceQuestionnaireNodeInput;
  CollaboratingUserEnteredSurfaceInput: CollaboratingUserEnteredSurfaceInput;
  CollaboratingUserLeftSurfaceInput: CollaboratingUserLeftSurfaceInput;
  CollaboratingUserCursorMovedOnSurfaceInput: CollaboratingUserCursorMovedOnSurfaceInput;
  SurfaceNodeMovedOnSurfaceInput: SurfaceNodeMovedOnSurfaceInput;
  UpdateUserInput: UpdateUserInput;
  ShareSurfaceWithUsersInput: ShareSurfaceWithUsersInput;
  ShareUserInput: ShareUserInput;
  ChangeUsersAccessOnSurfaceInput: ChangeUsersAccessOnSurfaceInput;
  UserAccessInput: UserAccessInput;
  AccessAction: AccessAction;
  RevokeUserAccessOnSurfaceInput: RevokeUserAccessOnSurfaceInput;
  DeleteUserInvitationResponsePayload: ResolverTypeWrapper<DeleteUserInvitationResponsePayload>;
  DeleteUserInvitationResponse: ResolverTypeWrapper<DeleteUserInvitationResponse>;
  NotificationPayload: ResolverTypeWrapper<NotificationPayload>;
  MarkAllNotificationsAsSeenResponsePayload: ResolverTypeWrapper<MarkAllNotificationsAsSeenResponsePayload>;
  MarkAllNotificationsAsSeenResponse: ResolverTypeWrapper<MarkAllNotificationsAsSeenResponse>;
  SignInCodePayload: ResolverTypeWrapper<SignInCodePayload>;
  MarkCodeAsUsedInput: MarkCodeAsUsedInput;
  CheckIfCodeIsUsedInput: CheckIfCodeIsUsedInput;
  Subscription: ResolverTypeWrapper<{}>;
  UserEnteredSurface: ResolverTypeWrapper<UserEnteredSurface>;
  UserLeftSurface: ResolverTypeWrapper<UserLeftSurface>;
  UserCurorMoved: ResolverTypeWrapper<UserCurorMoved>;
  SurfaceNodeMoved: ResolverTypeWrapper<SurfaceNodeMoved>;
  Date: ResolverTypeWrapper<Scalars['Date']>;
  ListPayloadTypeEnum: ListPayloadTypeEnum;
  Node: never;
  PaginationTypeEnum: PaginationTypeEnum;
  Surface: ResolverTypeWrapper<
    Omit<Surface, 'nodes'> & {
      nodes?: Maybe<Array<ResolversTypes['SurfaceNodeUnion']>>;
    }
  >;
  Time: ResolverTypeWrapper<Scalars['Time']>;
};

/** Mapping between all available schema types and the resolvers parents */
export type ResolversParentTypes = {
  Query: {};
  String: Scalars['String'];
  SurfaceHierarchyInput: SurfaceHierarchyInput;
  ID: Scalars['ID'];
  SurfaceHierarchyPayload: SurfaceHierarchyPayload;
  SubSurfaceNode: Omit<SubSurfaceNode, 'originalNode' | 'references'> & {
    originalNode?: Maybe<ResolversParentTypes['SurfaceNodeUnion']>;
    references?: Maybe<Array<Maybe<ResolversParentTypes['SurfaceNodeUnion']>>>;
  };
  SurfaceNode:
    | ResolversParentTypes['SubSurfaceNode']
    | ResolversParentTypes['SurfaceTextNode']
    | ResolversParentTypes['SurfaceTextNodeSnippet']
    | ResolversParentTypes['SurfaceNoteNode']
    | ResolversParentTypes['SurfaceDocumentNode']
    | ResolversParentTypes['SurfaceDocumentNodeSnippet']
    | ResolversParentTypes['SurfaceImageNode']
    | ResolversParentTypes['SurfaceProtocolNode']
    | ResolversParentTypes['SurfaceQuestionnaireNode'];
  Position: Position;
  Float: Scalars['Float'];
  SurfaceNodePointsTo: Omit<SurfaceNodePointsTo, 'from' | 'to'> & {
    from: ResolversParentTypes['SurfaceNodeUnion'];
    to: ResolversParentTypes['SurfaceNodeUnion'];
  };
  SurfaceNodeUnion:
    | ResolversParentTypes['SurfaceTextNode']
    | ResolversParentTypes['SurfaceDocumentNode']
    | ResolversParentTypes['SurfaceImageNode']
    | ResolversParentTypes['SurfaceNoteNode']
    | ResolversParentTypes['SurfaceProtocolNode']
    | ResolversParentTypes['SubSurfaceNode']
    | ResolversParentTypes['SurfaceQuestionnaireNode']
    | ResolversParentTypes['SurfaceTextNodeSnippet']
    | ResolversParentTypes['SurfaceDocumentNodeSnippet'];
  SurfaceTextNode: Omit<SurfaceTextNode, 'originalNode' | 'references'> & {
    originalNode?: Maybe<ResolversParentTypes['SurfaceNodeUnion']>;
    references?: Maybe<Array<Maybe<ResolversParentTypes['SurfaceNodeUnion']>>>;
  };
  JSON: Scalars['JSON'];
  SurfaceTextNodeSnippet: Omit<
    SurfaceTextNodeSnippet,
    'containerNode' | 'originalNode' | 'references'
  > & {
    containerNode?: Maybe<ResolversParentTypes['SurfaceContainerNodeUnion']>;
    originalNode?: Maybe<ResolversParentTypes['SurfaceNodeUnion']>;
    references?: Maybe<Array<Maybe<ResolversParentTypes['SurfaceNodeUnion']>>>;
  };
  SurfaceContainerNodeUnion:
    | ResolversParentTypes['SurfaceTextNode']
    | ResolversParentTypes['SurfaceNoteNode']
    | ResolversParentTypes['SurfaceDocumentNode'];
  SurfaceNoteNode: Omit<SurfaceNoteNode, 'originalNode' | 'references'> & {
    originalNode?: Maybe<ResolversParentTypes['SurfaceNodeUnion']>;
    references?: Maybe<Array<Maybe<ResolversParentTypes['SurfaceNodeUnion']>>>;
  };
  Boolean: Scalars['Boolean'];
  DateTime: Scalars['DateTime'];
  SurfaceDocumentNode: Omit<
    SurfaceDocumentNode,
    'originalNode' | 'references'
  > & {
    originalNode?: Maybe<ResolversParentTypes['SurfaceNodeUnion']>;
    references?: Maybe<Array<Maybe<ResolversParentTypes['SurfaceNodeUnion']>>>;
  };
  SurfaceDocumentNodeSnippet: Omit<
    SurfaceDocumentNodeSnippet,
    'containerNode' | 'originalNode' | 'references'
  > & {
    containerNode?: Maybe<ResolversParentTypes['SurfaceContainerNodeUnion']>;
    originalNode?: Maybe<ResolversParentTypes['SurfaceNodeUnion']>;
    references?: Maybe<Array<Maybe<ResolversParentTypes['SurfaceNodeUnion']>>>;
  };
  SurfaceImageNode: Omit<SurfaceImageNode, 'originalNode' | 'references'> & {
    originalNode?: Maybe<ResolversParentTypes['SurfaceNodeUnion']>;
    references?: Maybe<Array<Maybe<ResolversParentTypes['SurfaceNodeUnion']>>>;
  };
  SurfaceProtocolNode: Omit<
    SurfaceProtocolNode,
    'originalNode' | 'references' | 'contains'
  > & {
    originalNode?: Maybe<ResolversParentTypes['SurfaceNodeUnion']>;
    references?: Maybe<Array<Maybe<ResolversParentTypes['SurfaceNodeUnion']>>>;
    contains?: Maybe<
      ResolversParentTypes['SurfaceProtocolContainingNodeUnion']
    >;
  };
  SurfaceProtocolContainingNodeUnion:
    | ResolversParentTypes['SurfaceTextNode']
    | ResolversParentTypes['SurfaceDocumentNode']
    | ResolversParentTypes['SurfaceImageNode']
    | ResolversParentTypes['SurfaceNoteNode']
    | ResolversParentTypes['SubSurfaceNode']
    | ResolversParentTypes['SurfaceQuestionnaireNode']
    | ResolversParentTypes['SurfaceTextNodeSnippet']
    | ResolversParentTypes['SurfaceDocumentNodeSnippet'];
  SurfaceQuestionnaireNode: Omit<
    SurfaceQuestionnaireNode,
    'originalNode' | 'references'
  > & {
    originalNode?: Maybe<ResolversParentTypes['SurfaceNodeUnion']>;
    references?: Maybe<Array<Maybe<ResolversParentTypes['SurfaceNodeUnion']>>>;
  };
  SurfaceNodeLinkSettings: SurfaceNodeLinkSettings;
  User: User;
  SubSurfaceNodeListPayload: SubSurfaceNodeListPayload;
  PageInfo: PageInfo;
  SubSurfaceNodeEdge: SubSurfaceNodeEdge;
  ListPayloadMeta: ListPayloadMeta;
  Int: Scalars['Int'];
  OffsetPageInfo: OffsetPageInfo;
  SurfacesInput: SurfacesInput;
  CursorPagination: CursorPagination;
  OffsetPagination: OffsetPagination;
  SurfaceNodesInput: SurfaceNodesInput;
  SurfaceNodesFilter: SurfaceNodesFilter;
  SurfaceNodeUnionListPayload: Omit<SurfaceNodeUnionListPayload, 'nodes'> & {
    nodes?: Maybe<Array<Maybe<ResolversParentTypes['SurfaceNodeUnion']>>>;
  };
  SurfaceNodeUnionEdge: Omit<SurfaceNodeUnionEdge, 'node'> & {
    node?: Maybe<ResolversParentTypes['SurfaceNodeUnion']>;
  };
  SurfaceNodeUnionPayload: Omit<SurfaceNodeUnionPayload, 'data'> & {
    data?: Maybe<ResolversParentTypes['SurfaceNodeUnion']>;
  };
  RisSearchInput: RisSearchInput;
  RisSearchFilter: RisSearchFilter;
  RisSearchItemListPayload: RisSearchItemListPayload;
  RisSearchItemEdge: RisSearchItemEdge;
  RisSearchItem: RisSearchItem;
  undefinedPayload: UndefinedPayload;
  SubSurfaceNodePayload: SubSurfaceNodePayload;
  IntPayload: IntPayload;
  UserPayload: UserPayload;
  UserAccessUnionListPayload: Omit<UserAccessUnionListPayload, 'nodes'> & {
    nodes?: Maybe<Array<Maybe<ResolversParentTypes['UserAccessUnion']>>>;
  };
  UserAccessUnionEdge: Omit<UserAccessUnionEdge, 'node'> & {
    node?: Maybe<ResolversParentTypes['UserAccessUnion']>;
  };
  UserAccessUnion:
    | ResolversParentTypes['UserWithRole']
    | ResolversParentTypes['InvitationWithRole'];
  UserWithRole: UserWithRole;
  InvitationWithRole: InvitationWithRole;
  Invitation: Invitation;
  EmailAddress: Scalars['EmailAddress'];
  NotificationsInput: NotificationsInput;
  NotificationsFilter: NotificationsFilter;
  NotificationListPayload: NotificationListPayload;
  NotificationEdge: NotificationEdge;
  Notification: Notification;
  SignInCodesInput: SignInCodesInput;
  SignInCodesFilter: SignInCodesFilter;
  SignInCodeListPayload: SignInCodeListPayload;
  SignInCodeEdge: SignInCodeEdge;
  SignInCode: SignInCode;
  Mutation: {};
  CreateSurfaceInput: CreateSurfaceInput;
  SurfaceNodePositionInput: SurfaceNodePositionInput;
  LinkSurfaceNodesInput: LinkSurfaceNodesInput;
  SurfaceNodeLinkInput: SurfaceNodeLinkInput;
  LinkSurfaceNodesResultPayload: LinkSurfaceNodesResultPayload;
  LinkSurfaceNodesResult: Omit<
    LinkSurfaceNodesResult,
    'fromNode' | 'toNode'
  > & {
    fromNode: ResolversParentTypes['SurfaceNodeUnion'];
    toNode: ResolversParentTypes['SurfaceNodeUnion'];
  };
  UnLinkSurfaceNodesInput: UnLinkSurfaceNodesInput;
  UnLinkSurfaceNodesResultPayload: UnLinkSurfaceNodesResultPayload;
  UnLinkSurfaceNodesResult: UnLinkSurfaceNodesResult;
  UpdateSurfaceNodePositionInput: UpdateSurfaceNodePositionInput;
  CreateSurfaceNodeFileUploadUrlInput: CreateSurfaceNodeFileUploadUrlInput;
  SurfaceNodeFileInput: SurfaceNodeFileInput;
  CreateSurfaceNodeFileUploadUrlResultPayload: CreateSurfaceNodeFileUploadUrlResultPayload;
  CreateSurfaceNodeFileUploadUrlResult: CreateSurfaceNodeFileUploadUrlResult;
  CreateSurfaceNodeFileReadUrlInput: CreateSurfaceNodeFileReadUrlInput;
  CreateSurfaceNodeFileReadUrlResultPayload: CreateSurfaceNodeFileReadUrlResultPayload;
  CreateSurfaceNodeFileReadUrlResult: CreateSurfaceNodeFileReadUrlResult;
  UpdateSurfaceInput: UpdateSurfaceInput;
  DeleteSurfaceNodeRepsonsePayload: DeleteSurfaceNodeRepsonsePayload;
  DeleteSurfaceNodeRepsonse: Omit<
    DeleteSurfaceNodeRepsonse,
    'deletedSurfaceNode' | 'references'
  > & {
    deletedSurfaceNode: ResolversParentTypes['SurfaceNodeUnion'];
    references: Array<Maybe<ResolversParentTypes['SurfaceNodeUnion']>>;
  };
  SoftDeleteSurfaceNodeRepsonsePayload: SoftDeleteSurfaceNodeRepsonsePayload;
  SoftDeleteSurfaceNodeRepsonse: Omit<
    SoftDeleteSurfaceNodeRepsonse,
    'deletedSurfaceNode' | 'references'
  > & {
    deletedSurfaceNode: ResolversParentTypes['SurfaceNodeUnion'];
    references: Array<Maybe<ResolversParentTypes['SurfaceNodeUnion']>>;
  };
  CreateSurfaceTextNodeInput: CreateSurfaceTextNodeInput;
  TextSnippetInput: TextSnippetInput;
  UpdateSurfaceTextNodeInput: UpdateSurfaceTextNodeInput;
  CreateSurfaceRisDocumentNodeInput: CreateSurfaceRisDocumentNodeInput;
  DocumentSnippetInput: DocumentSnippetInput;
  URL: Scalars['URL'];
  CreateSurfaceDocumentNodeInput: CreateSurfaceDocumentNodeInput;
  UpdateSurfaceDocumentNodeInput: UpdateSurfaceDocumentNodeInput;
  CreateSurfaceImageNodeInput: CreateSurfaceImageNodeInput;
  UpdateSurfaceImageNodeInput: UpdateSurfaceImageNodeInput;
  CreateSurfaceNoteNodeInput: CreateSurfaceNoteNodeInput;
  UpdateSurfaceNoteNodeInput: UpdateSurfaceNoteNodeInput;
  CreateSurfaceProtocolNodeInput: CreateSurfaceProtocolNodeInput;
  UpdateSurfaceProtocolNodeInput: UpdateSurfaceProtocolNodeInput;
  AddSurfaceNodeToSurfaceProtocolNodeInput: AddSurfaceNodeToSurfaceProtocolNodeInput;
  EjectSurfaceNodeFromSurfaceProtocolNodeInput: EjectSurfaceNodeFromSurfaceProtocolNodeInput;
  CopySurfaceNodeInput: CopySurfaceNodeInput;
  PositionInput: PositionInput;
  CopySurfaceNodesInput: CopySurfaceNodesInput;
  CutSurfaceNodeInput: CutSurfaceNodeInput;
  CutSurfaceNodesInput: CutSurfaceNodesInput;
  CopySurfaceNodeByReferenceInput: CopySurfaceNodeByReferenceInput;
  CopySurfaceNodesByReferenceInput: CopySurfaceNodesByReferenceInput;
  CreateSurfaceDocumentNodeSnippetInput: CreateSurfaceDocumentNodeSnippetInput;
  SurfaceDocumentNodeSnippetPayload: SurfaceDocumentNodeSnippetPayload;
  UpdateSurfaceDocumentNodeSnippetInput: UpdateSurfaceDocumentNodeSnippetInput;
  CreateSurfaceTextNodeSnippetInput: CreateSurfaceTextNodeSnippetInput;
  SurfaceTextNodeSnippetPayload: SurfaceTextNodeSnippetPayload;
  UpdateSurfaceTextNodeSnippetInput: UpdateSurfaceTextNodeSnippetInput;
  UpdateSurfaceNodeLinkSettingsInput: UpdateSurfaceNodeLinkSettingsInput;
  SurfaceNodeLinkSettingsInput: SurfaceNodeLinkSettingsInput;
  SurfaceNodeLinkSettingsPayload: SurfaceNodeLinkSettingsPayload;
  CreateSurfaceQuestionnaireNodeInput: CreateSurfaceQuestionnaireNodeInput;
  UpdateSurfaceQuestionnaireNodeInput: UpdateSurfaceQuestionnaireNodeInput;
  CollaboratingUserEnteredSurfaceInput: CollaboratingUserEnteredSurfaceInput;
  CollaboratingUserLeftSurfaceInput: CollaboratingUserLeftSurfaceInput;
  CollaboratingUserCursorMovedOnSurfaceInput: CollaboratingUserCursorMovedOnSurfaceInput;
  SurfaceNodeMovedOnSurfaceInput: SurfaceNodeMovedOnSurfaceInput;
  UpdateUserInput: UpdateUserInput;
  ShareSurfaceWithUsersInput: ShareSurfaceWithUsersInput;
  ShareUserInput: ShareUserInput;
  ChangeUsersAccessOnSurfaceInput: ChangeUsersAccessOnSurfaceInput;
  UserAccessInput: UserAccessInput;
  RevokeUserAccessOnSurfaceInput: RevokeUserAccessOnSurfaceInput;
  DeleteUserInvitationResponsePayload: DeleteUserInvitationResponsePayload;
  DeleteUserInvitationResponse: DeleteUserInvitationResponse;
  NotificationPayload: NotificationPayload;
  MarkAllNotificationsAsSeenResponsePayload: MarkAllNotificationsAsSeenResponsePayload;
  MarkAllNotificationsAsSeenResponse: MarkAllNotificationsAsSeenResponse;
  SignInCodePayload: SignInCodePayload;
  MarkCodeAsUsedInput: MarkCodeAsUsedInput;
  CheckIfCodeIsUsedInput: CheckIfCodeIsUsedInput;
  Subscription: {};
  UserEnteredSurface: UserEnteredSurface;
  UserLeftSurface: UserLeftSurface;
  UserCurorMoved: UserCurorMoved;
  SurfaceNodeMoved: SurfaceNodeMoved;
  Date: Scalars['Date'];
  Node: never;
  Surface: Omit<Surface, 'nodes'> & {
    nodes?: Maybe<Array<ResolversParentTypes['SurfaceNodeUnion']>>;
  };
  Time: Scalars['Time'];
};

export type CreateSurfaceNodeFileReadUrlResultResolvers<
  ContextType = IContext,
  ParentType extends ResolversParentTypes['CreateSurfaceNodeFileReadUrlResult'] = ResolversParentTypes['CreateSurfaceNodeFileReadUrlResult']
> = {
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  bucketName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  region?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateSurfaceNodeFileReadUrlResultPayloadResolvers<
  ContextType = IContext,
  ParentType extends ResolversParentTypes['CreateSurfaceNodeFileReadUrlResultPayload'] = ResolversParentTypes['CreateSurfaceNodeFileReadUrlResultPayload']
> = {
  data?: Resolver<
    Maybe<ResolversTypes['CreateSurfaceNodeFileReadUrlResult']>,
    ParentType,
    ContextType
  >;
  error?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  success?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateSurfaceNodeFileUploadUrlResultResolvers<
  ContextType = IContext,
  ParentType extends ResolversParentTypes['CreateSurfaceNodeFileUploadUrlResult'] = ResolversParentTypes['CreateSurfaceNodeFileUploadUrlResult']
> = {
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  bucketName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  region?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateSurfaceNodeFileUploadUrlResultPayloadResolvers<
  ContextType = IContext,
  ParentType extends ResolversParentTypes['CreateSurfaceNodeFileUploadUrlResultPayload'] = ResolversParentTypes['CreateSurfaceNodeFileUploadUrlResultPayload']
> = {
  data?: Resolver<
    Maybe<ResolversTypes['CreateSurfaceNodeFileUploadUrlResult']>,
    ParentType,
    ContextType
  >;
  error?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  success?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface DateScalarConfig
  extends GraphQLScalarTypeConfig<ResolversTypes['Date'], any> {
  name: 'Date';
}

export interface DateTimeScalarConfig
  extends GraphQLScalarTypeConfig<ResolversTypes['DateTime'], any> {
  name: 'DateTime';
}

export type DeleteSurfaceNodeRepsonseResolvers<
  ContextType = IContext,
  ParentType extends ResolversParentTypes['DeleteSurfaceNodeRepsonse'] = ResolversParentTypes['DeleteSurfaceNodeRepsonse']
> = {
  deletedSurfaceNode?: Resolver<
    ResolversTypes['SurfaceNodeUnion'],
    ParentType,
    ContextType
  >;
  references?: Resolver<
    Array<Maybe<ResolversTypes['SurfaceNodeUnion']>>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteSurfaceNodeRepsonsePayloadResolvers<
  ContextType = IContext,
  ParentType extends ResolversParentTypes['DeleteSurfaceNodeRepsonsePayload'] = ResolversParentTypes['DeleteSurfaceNodeRepsonsePayload']
> = {
  data?: Resolver<
    Maybe<ResolversTypes['DeleteSurfaceNodeRepsonse']>,
    ParentType,
    ContextType
  >;
  error?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  success?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteUserInvitationResponseResolvers<
  ContextType = IContext,
  ParentType extends ResolversParentTypes['DeleteUserInvitationResponse'] = ResolversParentTypes['DeleteUserInvitationResponse']
> = {
  isSuccess?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeleteUserInvitationResponsePayloadResolvers<
  ContextType = IContext,
  ParentType extends ResolversParentTypes['DeleteUserInvitationResponsePayload'] = ResolversParentTypes['DeleteUserInvitationResponsePayload']
> = {
  data?: Resolver<
    Maybe<ResolversTypes['DeleteUserInvitationResponse']>,
    ParentType,
    ContextType
  >;
  error?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  success?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface EmailAddressScalarConfig
  extends GraphQLScalarTypeConfig<ResolversTypes['EmailAddress'], any> {
  name: 'EmailAddress';
}

export type IntPayloadResolvers<
  ContextType = IContext,
  ParentType extends ResolversParentTypes['IntPayload'] = ResolversParentTypes['IntPayload']
> = {
  data?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  error?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  success?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InvitationResolvers<
  ContextType = IContext,
  ParentType extends ResolversParentTypes['Invitation'] = ResolversParentTypes['Invitation']
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  email?: Resolver<ResolversTypes['EmailAddress'], ParentType, ContextType>;
  role?: Resolver<ResolversTypes['SurfaceRole'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InvitationWithRoleResolvers<
  ContextType = IContext,
  ParentType extends ResolversParentTypes['InvitationWithRole'] = ResolversParentTypes['InvitationWithRole']
> = {
  invitation?: Resolver<ResolversTypes['Invitation'], ParentType, ContextType>;
  role?: Resolver<ResolversTypes['SurfaceRole'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface JsonScalarConfig
  extends GraphQLScalarTypeConfig<ResolversTypes['JSON'], any> {
  name: 'JSON';
}

export type LinkSurfaceNodesResultResolvers<
  ContextType = IContext,
  ParentType extends ResolversParentTypes['LinkSurfaceNodesResult'] = ResolversParentTypes['LinkSurfaceNodesResult']
> = {
  fromNode?: Resolver<
    ResolversTypes['SurfaceNodeUnion'],
    ParentType,
    ContextType
  >;
  toNode?: Resolver<
    ResolversTypes['SurfaceNodeUnion'],
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LinkSurfaceNodesResultPayloadResolvers<
  ContextType = IContext,
  ParentType extends ResolversParentTypes['LinkSurfaceNodesResultPayload'] = ResolversParentTypes['LinkSurfaceNodesResultPayload']
> = {
  data?: Resolver<
    Maybe<ResolversTypes['LinkSurfaceNodesResult']>,
    ParentType,
    ContextType
  >;
  error?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  success?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ListPayloadMetaResolvers<
  ContextType = IContext,
  ParentType extends ResolversParentTypes['ListPayloadMeta'] = ResolversParentTypes['ListPayloadMeta']
> = {
  totalCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  totalPages?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  offset?: Resolver<
    Maybe<ResolversTypes['OffsetPageInfo']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MarkAllNotificationsAsSeenResponseResolvers<
  ContextType = IContext,
  ParentType extends ResolversParentTypes['MarkAllNotificationsAsSeenResponse'] = ResolversParentTypes['MarkAllNotificationsAsSeenResponse']
> = {
  isSuccess?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MarkAllNotificationsAsSeenResponsePayloadResolvers<
  ContextType = IContext,
  ParentType extends ResolversParentTypes['MarkAllNotificationsAsSeenResponsePayload'] = ResolversParentTypes['MarkAllNotificationsAsSeenResponsePayload']
> = {
  data?: Resolver<
    Maybe<ResolversTypes['MarkAllNotificationsAsSeenResponse']>,
    ParentType,
    ContextType
  >;
  error?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  success?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MutationResolvers<
  ContextType = IContext,
  ParentType extends ResolversParentTypes['Mutation'] = ResolversParentTypes['Mutation']
> = {
  _?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createSurface?: Resolver<
    Maybe<ResolversTypes['SubSurfaceNodePayload']>,
    ParentType,
    ContextType,
    RequireFields<MutationCreateSurfaceArgs, 'input'>
  >;
  linkSurfaceNodes?: Resolver<
    Maybe<ResolversTypes['LinkSurfaceNodesResultPayload']>,
    ParentType,
    ContextType,
    RequireFields<MutationLinkSurfaceNodesArgs, 'input'>
  >;
  unLinkSurfaceNodes?: Resolver<
    Maybe<ResolversTypes['UnLinkSurfaceNodesResultPayload']>,
    ParentType,
    ContextType,
    RequireFields<MutationUnLinkSurfaceNodesArgs, 'input'>
  >;
  updateSurfaceNodePosition?: Resolver<
    Maybe<ResolversTypes['SurfaceNodeUnionPayload']>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdateSurfaceNodePositionArgs, 'input'>
  >;
  createSurfaceNodeFileUploadUrl?: Resolver<
    Maybe<ResolversTypes['CreateSurfaceNodeFileUploadUrlResultPayload']>,
    ParentType,
    ContextType,
    RequireFields<MutationCreateSurfaceNodeFileUploadUrlArgs, 'input'>
  >;
  createSurfaceNodeFileReadUrl?: Resolver<
    Maybe<ResolversTypes['CreateSurfaceNodeFileReadUrlResultPayload']>,
    ParentType,
    ContextType,
    RequireFields<MutationCreateSurfaceNodeFileReadUrlArgs, 'input'>
  >;
  updateSurface?: Resolver<
    Maybe<ResolversTypes['SubSurfaceNodePayload']>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdateSurfaceArgs, 'input'>
  >;
  deleteSurfaceNode?: Resolver<
    Maybe<ResolversTypes['DeleteSurfaceNodeRepsonsePayload']>,
    ParentType,
    ContextType,
    RequireFields<MutationDeleteSurfaceNodeArgs, 'id'>
  >;
  softDeleteSurfaceNode?: Resolver<
    Maybe<ResolversTypes['SoftDeleteSurfaceNodeRepsonsePayload']>,
    ParentType,
    ContextType,
    RequireFields<MutationSoftDeleteSurfaceNodeArgs, 'id'>
  >;
  createSurfaceTextNode?: Resolver<
    Maybe<ResolversTypes['SurfaceNodeUnionPayload']>,
    ParentType,
    ContextType,
    RequireFields<MutationCreateSurfaceTextNodeArgs, 'input'>
  >;
  updateSurfaceTextNode?: Resolver<
    Maybe<ResolversTypes['SurfaceNodeUnionPayload']>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdateSurfaceTextNodeArgs, 'input'>
  >;
  createSurfaceRisDocumentNode?: Resolver<
    Maybe<ResolversTypes['SurfaceNodeUnionPayload']>,
    ParentType,
    ContextType,
    RequireFields<MutationCreateSurfaceRisDocumentNodeArgs, 'input'>
  >;
  createSurfaceDocumentNode?: Resolver<
    Maybe<ResolversTypes['SurfaceNodeUnionPayload']>,
    ParentType,
    ContextType,
    RequireFields<MutationCreateSurfaceDocumentNodeArgs, 'input'>
  >;
  updateSurfaceDocumentNode?: Resolver<
    Maybe<ResolversTypes['SurfaceNodeUnionPayload']>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdateSurfaceDocumentNodeArgs, 'input'>
  >;
  createSurfaceImageNode?: Resolver<
    Maybe<ResolversTypes['SurfaceNodeUnionPayload']>,
    ParentType,
    ContextType,
    RequireFields<MutationCreateSurfaceImageNodeArgs, 'input'>
  >;
  updateSurfaceImageNode?: Resolver<
    Maybe<ResolversTypes['SurfaceNodeUnionPayload']>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdateSurfaceImageNodeArgs, 'input'>
  >;
  createSurfaceNoteNode?: Resolver<
    Maybe<ResolversTypes['SurfaceNodeUnionPayload']>,
    ParentType,
    ContextType,
    RequireFields<MutationCreateSurfaceNoteNodeArgs, 'input'>
  >;
  updateSurfaceNoteNode?: Resolver<
    Maybe<ResolversTypes['SurfaceNodeUnionPayload']>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdateSurfaceNoteNodeArgs, 'input'>
  >;
  createSurfaceProtocolNode?: Resolver<
    Maybe<ResolversTypes['SurfaceNodeUnionPayload']>,
    ParentType,
    ContextType,
    RequireFields<MutationCreateSurfaceProtocolNodeArgs, 'input'>
  >;
  updateSurfaceProtocolNode?: Resolver<
    Maybe<ResolversTypes['SurfaceNodeUnionPayload']>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdateSurfaceProtocolNodeArgs, 'input'>
  >;
  addSurfaceNodeToSurfaceProtocolNode?: Resolver<
    Maybe<ResolversTypes['SurfaceNodeUnionPayload']>,
    ParentType,
    ContextType,
    RequireFields<MutationAddSurfaceNodeToSurfaceProtocolNodeArgs, 'input'>
  >;
  ejectSurfaceNodeFromSurfaceProtocolNode?: Resolver<
    Maybe<ResolversTypes['SurfaceNodeUnionPayload']>,
    ParentType,
    ContextType,
    RequireFields<MutationEjectSurfaceNodeFromSurfaceProtocolNodeArgs, 'input'>
  >;
  copySurfaceNode?: Resolver<
    Maybe<ResolversTypes['SurfaceNodeUnionPayload']>,
    ParentType,
    ContextType,
    RequireFields<MutationCopySurfaceNodeArgs, 'input'>
  >;
  copySurfaceNodes?: Resolver<
    Array<ResolversTypes['SurfaceNodeUnion']>,
    ParentType,
    ContextType,
    RequireFields<MutationCopySurfaceNodesArgs, 'input'>
  >;
  cutSurfaceNode?: Resolver<
    Maybe<ResolversTypes['SurfaceNodeUnionPayload']>,
    ParentType,
    ContextType,
    RequireFields<MutationCutSurfaceNodeArgs, 'input'>
  >;
  cutSurfaceNodes?: Resolver<
    Array<ResolversTypes['SurfaceNodeUnion']>,
    ParentType,
    ContextType,
    RequireFields<MutationCutSurfaceNodesArgs, 'input'>
  >;
  copySurfaceNodeByReference?: Resolver<
    Maybe<ResolversTypes['SurfaceNodeUnionPayload']>,
    ParentType,
    ContextType,
    RequireFields<MutationCopySurfaceNodeByReferenceArgs, 'input'>
  >;
  copySurfaceNodesByReference?: Resolver<
    Array<ResolversTypes['SurfaceNodeUnion']>,
    ParentType,
    ContextType,
    RequireFields<MutationCopySurfaceNodesByReferenceArgs, 'input'>
  >;
  deleteSurfaceNodes?: Resolver<
    Array<ResolversTypes['DeleteSurfaceNodeRepsonse']>,
    ParentType,
    ContextType,
    RequireFields<MutationDeleteSurfaceNodesArgs, 'ids'>
  >;
  softDeleteSurfaceNodes?: Resolver<
    Array<ResolversTypes['SoftDeleteSurfaceNodeRepsonse']>,
    ParentType,
    ContextType,
    RequireFields<MutationSoftDeleteSurfaceNodesArgs, 'ids'>
  >;
  createSurfaceDocumentNodeSnippet?: Resolver<
    Maybe<ResolversTypes['SurfaceDocumentNodeSnippetPayload']>,
    ParentType,
    ContextType,
    RequireFields<MutationCreateSurfaceDocumentNodeSnippetArgs, 'input'>
  >;
  updateSurfaceDocumentNodeSnippet?: Resolver<
    Maybe<ResolversTypes['SurfaceDocumentNodeSnippetPayload']>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdateSurfaceDocumentNodeSnippetArgs, 'input'>
  >;
  createSurfaceTextNodeSnippet?: Resolver<
    Maybe<ResolversTypes['SurfaceTextNodeSnippetPayload']>,
    ParentType,
    ContextType,
    RequireFields<MutationCreateSurfaceTextNodeSnippetArgs, 'input'>
  >;
  updateSurfaceTextNodeSnippet?: Resolver<
    Maybe<ResolversTypes['SurfaceTextNodeSnippetPayload']>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdateSurfaceTextNodeSnippetArgs, 'input'>
  >;
  updateSurfaceNodeLinkSettings?: Resolver<
    Maybe<ResolversTypes['SurfaceNodeLinkSettingsPayload']>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdateSurfaceNodeLinkSettingsArgs, 'input'>
  >;
  createSurfaceQuestionnaireNode?: Resolver<
    Maybe<ResolversTypes['SurfaceNodeUnionPayload']>,
    ParentType,
    ContextType,
    RequireFields<MutationCreateSurfaceQuestionnaireNodeArgs, 'input'>
  >;
  updateSurfaceQuestionnaireNode?: Resolver<
    Maybe<ResolversTypes['SurfaceNodeUnionPayload']>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdateSurfaceQuestionnaireNodeArgs, 'input'>
  >;
  collaboratingUserEnteredSurface?: Resolver<
    Maybe<ResolversTypes['Boolean']>,
    ParentType,
    ContextType,
    RequireFields<MutationCollaboratingUserEnteredSurfaceArgs, 'input'>
  >;
  collaboratingUserLeftSurface?: Resolver<
    Maybe<ResolversTypes['Boolean']>,
    ParentType,
    ContextType,
    RequireFields<MutationCollaboratingUserLeftSurfaceArgs, 'input'>
  >;
  collaboratingUserCursorMovedOnSurface?: Resolver<
    Maybe<ResolversTypes['Boolean']>,
    ParentType,
    ContextType,
    RequireFields<MutationCollaboratingUserCursorMovedOnSurfaceArgs, 'input'>
  >;
  surfaceNodeMovedOnSurface?: Resolver<
    Maybe<ResolversTypes['Boolean']>,
    ParentType,
    ContextType,
    RequireFields<MutationSurfaceNodeMovedOnSurfaceArgs, 'input'>
  >;
  updateUser?: Resolver<
    Maybe<ResolversTypes['UserPayload']>,
    ParentType,
    ContextType,
    RequireFields<MutationUpdateUserArgs, 'input'>
  >;
  shareSurfaceWithUsers?: Resolver<
    Maybe<ResolversTypes['UserPayload']>,
    ParentType,
    ContextType,
    RequireFields<MutationShareSurfaceWithUsersArgs, 'input'>
  >;
  changeUsersAccessOnSurface?: Resolver<
    Maybe<ResolversTypes['UserPayload']>,
    ParentType,
    ContextType,
    RequireFields<MutationChangeUsersAccessOnSurfaceArgs, 'input'>
  >;
  revokeUserAccessOnSurface?: Resolver<
    Maybe<ResolversTypes['UserPayload']>,
    ParentType,
    ContextType,
    RequireFields<MutationRevokeUserAccessOnSurfaceArgs, 'input'>
  >;
  deleteUserInvitation?: Resolver<
    Maybe<ResolversTypes['DeleteUserInvitationResponsePayload']>,
    ParentType,
    ContextType,
    RequireFields<MutationDeleteUserInvitationArgs, 'id'>
  >;
  markNotificationAsSeen?: Resolver<
    Maybe<ResolversTypes['NotificationPayload']>,
    ParentType,
    ContextType,
    RequireFields<MutationMarkNotificationAsSeenArgs, 'id'>
  >;
  markAllNotificationsAsSeen?: Resolver<
    Maybe<ResolversTypes['MarkAllNotificationsAsSeenResponsePayload']>,
    ParentType,
    ContextType
  >;
  createSignInCode?: Resolver<
    Maybe<ResolversTypes['SignInCodePayload']>,
    ParentType,
    ContextType
  >;
  markCodeAsUsed?: Resolver<
    Maybe<ResolversTypes['SignInCodePayload']>,
    ParentType,
    ContextType,
    RequireFields<MutationMarkCodeAsUsedArgs, 'input'>
  >;
  checkIfCodeIsUsed?: Resolver<
    Maybe<ResolversTypes['SignInCodePayload']>,
    ParentType,
    ContextType,
    RequireFields<MutationCheckIfCodeIsUsedArgs, 'input'>
  >;
};

export type NodeResolvers<
  ContextType = IContext,
  ParentType extends ResolversParentTypes['Node'] = ResolversParentTypes['Node']
> = {
  __resolveType: TypeResolveFn<null, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
};

export type NotificationResolvers<
  ContextType = IContext,
  ParentType extends ResolversParentTypes['Notification'] = ResolversParentTypes['Notification']
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['NotificationType'], ParentType, ContextType>;
  status?: Resolver<
    ResolversTypes['NotificationStatus'],
    ParentType,
    ContextType
  >;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sender?: Resolver<ResolversTypes['User'], ParentType, ContextType>;
  receiver?: Resolver<ResolversTypes['User'], ParentType, ContextType>;
  surface?: Resolver<
    Maybe<ResolversTypes['SubSurfaceNode']>,
    ParentType,
    ContextType
  >;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NotificationEdgeResolvers<
  ContextType = IContext,
  ParentType extends ResolversParentTypes['NotificationEdge'] = ResolversParentTypes['NotificationEdge']
> = {
  node?: Resolver<
    Maybe<ResolversTypes['Notification']>,
    ParentType,
    ContextType
  >;
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NotificationListPayloadResolvers<
  ContextType = IContext,
  ParentType extends ResolversParentTypes['NotificationListPayload'] = ResolversParentTypes['NotificationListPayload']
> = {
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  edges?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['NotificationEdge']>>>,
    ParentType,
    ContextType
  >;
  meta?: Resolver<
    Maybe<ResolversTypes['ListPayloadMeta']>,
    ParentType,
    ContextType
  >;
  error?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  nodes?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['Notification']>>>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type NotificationPayloadResolvers<
  ContextType = IContext,
  ParentType extends ResolversParentTypes['NotificationPayload'] = ResolversParentTypes['NotificationPayload']
> = {
  data?: Resolver<
    Maybe<ResolversTypes['Notification']>,
    ParentType,
    ContextType
  >;
  error?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  success?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OffsetPageInfoResolvers<
  ContextType = IContext,
  ParentType extends ResolversParentTypes['OffsetPageInfo'] = ResolversParentTypes['OffsetPageInfo']
> = {
  page?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  perPage?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PageInfoResolvers<
  ContextType = IContext,
  ParentType extends ResolversParentTypes['PageInfo'] = ResolversParentTypes['PageInfo']
> = {
  hasNextPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  hasPreviousPage?: Resolver<
    ResolversTypes['Boolean'],
    ParentType,
    ContextType
  >;
  startCursor?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  endCursor?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PositionResolvers<
  ContextType = IContext,
  ParentType extends ResolversParentTypes['Position'] = ResolversParentTypes['Position']
> = {
  x?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  y?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type QueryResolvers<
  ContextType = IContext,
  ParentType extends ResolversParentTypes['Query'] = ResolversParentTypes['Query']
> = {
  _?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  surfaceHierarchy?: Resolver<
    Maybe<ResolversTypes['SurfaceHierarchyPayload']>,
    ParentType,
    ContextType,
    RequireFields<QuerySurfaceHierarchyArgs, 'input'>
  >;
  surfaces?: Resolver<
    Maybe<ResolversTypes['SubSurfaceNodeListPayload']>,
    ParentType,
    ContextType,
    RequireFields<QuerySurfacesArgs, never>
  >;
  surfaceNodes?: Resolver<
    Maybe<ResolversTypes['SurfaceNodeUnionListPayload']>,
    ParentType,
    ContextType,
    RequireFields<QuerySurfaceNodesArgs, never>
  >;
  surfaceNode?: Resolver<
    Maybe<ResolversTypes['SurfaceNodeUnionPayload']>,
    ParentType,
    ContextType,
    RequireFields<QuerySurfaceNodeArgs, 'id'>
  >;
  risSearch?: Resolver<
    Maybe<ResolversTypes['RisSearchItemListPayload']>,
    ParentType,
    ContextType,
    RequireFields<QueryRisSearchArgs, never>
  >;
  isSurfaceShared?: Resolver<
    Maybe<ResolversTypes['undefinedPayload']>,
    ParentType,
    ContextType,
    RequireFields<QueryIsSurfaceSharedArgs, 'id'>
  >;
  homeSurface?: Resolver<
    Maybe<ResolversTypes['SubSurfaceNodePayload']>,
    ParentType,
    ContextType
  >;
  subSurfacesCount?: Resolver<
    Maybe<ResolversTypes['IntPayload']>,
    ParentType,
    ContextType,
    RequireFields<QuerySubSurfacesCountArgs, 'surface'>
  >;
  fetchLoggedUser?: Resolver<
    Maybe<ResolversTypes['UserPayload']>,
    ParentType,
    ContextType
  >;
  fetchUsersWithAccessToSurface?: Resolver<
    Maybe<ResolversTypes['UserAccessUnionListPayload']>,
    ParentType,
    ContextType,
    RequireFields<QueryFetchUsersWithAccessToSurfaceArgs, 'surface'>
  >;
  notifications?: Resolver<
    Maybe<ResolversTypes['NotificationListPayload']>,
    ParentType,
    ContextType,
    RequireFields<QueryNotificationsArgs, never>
  >;
  signInCodes?: Resolver<
    Maybe<ResolversTypes['SignInCodeListPayload']>,
    ParentType,
    ContextType,
    RequireFields<QuerySignInCodesArgs, never>
  >;
};

export type RisSearchItemResolvers<
  ContextType = IContext,
  ParentType extends ResolversParentTypes['RisSearchItem'] = ResolversParentTypes['RisSearchItem']
> = {
  id?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  url?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lawName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  date?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  risUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RisSearchItemEdgeResolvers<
  ContextType = IContext,
  ParentType extends ResolversParentTypes['RisSearchItemEdge'] = ResolversParentTypes['RisSearchItemEdge']
> = {
  node?: Resolver<
    Maybe<ResolversTypes['RisSearchItem']>,
    ParentType,
    ContextType
  >;
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RisSearchItemListPayloadResolvers<
  ContextType = IContext,
  ParentType extends ResolversParentTypes['RisSearchItemListPayload'] = ResolversParentTypes['RisSearchItemListPayload']
> = {
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  edges?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['RisSearchItemEdge']>>>,
    ParentType,
    ContextType
  >;
  meta?: Resolver<
    Maybe<ResolversTypes['ListPayloadMeta']>,
    ParentType,
    ContextType
  >;
  error?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  nodes?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['RisSearchItem']>>>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SignInCodeResolvers<
  ContextType = IContext,
  ParentType extends ResolversParentTypes['SignInCode'] = ResolversParentTypes['SignInCode']
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  code?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  usedOn?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SignInCodeEdgeResolvers<
  ContextType = IContext,
  ParentType extends ResolversParentTypes['SignInCodeEdge'] = ResolversParentTypes['SignInCodeEdge']
> = {
  node?: Resolver<Maybe<ResolversTypes['SignInCode']>, ParentType, ContextType>;
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SignInCodeListPayloadResolvers<
  ContextType = IContext,
  ParentType extends ResolversParentTypes['SignInCodeListPayload'] = ResolversParentTypes['SignInCodeListPayload']
> = {
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  edges?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['SignInCodeEdge']>>>,
    ParentType,
    ContextType
  >;
  meta?: Resolver<
    Maybe<ResolversTypes['ListPayloadMeta']>,
    ParentType,
    ContextType
  >;
  error?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  nodes?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['SignInCode']>>>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SignInCodePayloadResolvers<
  ContextType = IContext,
  ParentType extends ResolversParentTypes['SignInCodePayload'] = ResolversParentTypes['SignInCodePayload']
> = {
  data?: Resolver<Maybe<ResolversTypes['SignInCode']>, ParentType, ContextType>;
  error?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  success?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SoftDeleteSurfaceNodeRepsonseResolvers<
  ContextType = IContext,
  ParentType extends ResolversParentTypes['SoftDeleteSurfaceNodeRepsonse'] = ResolversParentTypes['SoftDeleteSurfaceNodeRepsonse']
> = {
  deletedSurfaceNode?: Resolver<
    ResolversTypes['SurfaceNodeUnion'],
    ParentType,
    ContextType
  >;
  references?: Resolver<
    Array<Maybe<ResolversTypes['SurfaceNodeUnion']>>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SoftDeleteSurfaceNodeRepsonsePayloadResolvers<
  ContextType = IContext,
  ParentType extends ResolversParentTypes['SoftDeleteSurfaceNodeRepsonsePayload'] = ResolversParentTypes['SoftDeleteSurfaceNodeRepsonsePayload']
> = {
  data?: Resolver<
    Maybe<ResolversTypes['SoftDeleteSurfaceNodeRepsonse']>,
    ParentType,
    ContextType
  >;
  error?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  success?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SubscriptionResolvers<
  ContextType = IContext,
  ParentType extends ResolversParentTypes['Subscription'] = ResolversParentTypes['Subscription']
> = {
  _?: SubscriptionResolver<
    Maybe<ResolversTypes['String']>,
    '_',
    ParentType,
    ContextType
  >;
  surfaceNodeCreated?: SubscriptionResolver<
    Maybe<ResolversTypes['SurfaceNodeUnion']>,
    'surfaceNodeCreated',
    ParentType,
    ContextType,
    RequireFields<SubscriptionSurfaceNodeCreatedArgs, 'surface'>
  >;
  surfaceNodeUpdated?: SubscriptionResolver<
    Maybe<ResolversTypes['SurfaceNodeUnion']>,
    'surfaceNodeUpdated',
    ParentType,
    ContextType,
    RequireFields<SubscriptionSurfaceNodeUpdatedArgs, 'surface'>
  >;
  surfaceNodePositionUpdated?: SubscriptionResolver<
    Maybe<ResolversTypes['SurfaceNodeUnion']>,
    'surfaceNodePositionUpdated',
    ParentType,
    ContextType,
    RequireFields<SubscriptionSurfaceNodePositionUpdatedArgs, 'surface'>
  >;
  surfaceNodeDeleted?: SubscriptionResolver<
    Maybe<ResolversTypes['SurfaceNodeUnion']>,
    'surfaceNodeDeleted',
    ParentType,
    ContextType,
    RequireFields<SubscriptionSurfaceNodeDeletedArgs, 'surface'>
  >;
  surfaceNodePasted?: SubscriptionResolver<
    Maybe<ResolversTypes['SurfaceNodeUnion']>,
    'surfaceNodePasted',
    ParentType,
    ContextType,
    RequireFields<SubscriptionSurfaceNodePastedArgs, 'surface'>
  >;
  surfaceNodesLinked?: SubscriptionResolver<
    Maybe<ResolversTypes['SurfaceNodeUnion']>,
    'surfaceNodesLinked',
    ParentType,
    ContextType,
    RequireFields<SubscriptionSurfaceNodesLinkedArgs, 'surface'>
  >;
  surfaceNodesUnlinked?: SubscriptionResolver<
    Maybe<ResolversTypes['SurfaceNodeUnion']>,
    'surfaceNodesUnlinked',
    ParentType,
    ContextType,
    RequireFields<SubscriptionSurfaceNodesUnlinkedArgs, 'surface'>
  >;
  collaboratingUserEnteredSurfaceSubscription?: SubscriptionResolver<
    Maybe<ResolversTypes['UserEnteredSurface']>,
    'collaboratingUserEnteredSurfaceSubscription',
    ParentType,
    ContextType,
    RequireFields<
      SubscriptionCollaboratingUserEnteredSurfaceSubscriptionArgs,
      'surface'
    >
  >;
  collaboratingUserLeftSurfaceSubscription?: SubscriptionResolver<
    Maybe<ResolversTypes['UserLeftSurface']>,
    'collaboratingUserLeftSurfaceSubscription',
    ParentType,
    ContextType,
    RequireFields<
      SubscriptionCollaboratingUserLeftSurfaceSubscriptionArgs,
      'surface'
    >
  >;
  collaboratingUserCursorMovedOnSurfaceSubscription?: SubscriptionResolver<
    Maybe<ResolversTypes['UserCurorMoved']>,
    'collaboratingUserCursorMovedOnSurfaceSubscription',
    ParentType,
    ContextType,
    RequireFields<
      SubscriptionCollaboratingUserCursorMovedOnSurfaceSubscriptionArgs,
      'surface'
    >
  >;
  surfaceNodeShared?: SubscriptionResolver<
    Maybe<ResolversTypes['SubSurfaceNode']>,
    'surfaceNodeShared',
    ParentType,
    ContextType,
    RequireFields<SubscriptionSurfaceNodeSharedArgs, 'sharedSurfacesRoot'>
  >;
  surfaceNodeRevoked?: SubscriptionResolver<
    Maybe<ResolversTypes['SubSurfaceNode']>,
    'surfaceNodeRevoked',
    ParentType,
    ContextType,
    RequireFields<SubscriptionSurfaceNodeRevokedArgs, 'sharedSurfacesRoot'>
  >;
  surfaceNodeMoved?: SubscriptionResolver<
    Maybe<ResolversTypes['SurfaceNodeMoved']>,
    'surfaceNodeMoved',
    ParentType,
    ContextType,
    RequireFields<SubscriptionSurfaceNodeMovedArgs, 'surface'>
  >;
  userNotificationCreated?: SubscriptionResolver<
    Maybe<ResolversTypes['Notification']>,
    'userNotificationCreated',
    ParentType,
    ContextType,
    RequireFields<SubscriptionUserNotificationCreatedArgs, 'user'>
  >;
};

export type SubSurfaceNodeResolvers<
  ContextType = IContext,
  ParentType extends ResolversParentTypes['SubSurfaceNode'] = ResolversParentTypes['SubSurfaceNode']
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  surface?: Resolver<
    Maybe<ResolversTypes['SubSurfaceNode']>,
    ParentType,
    ContextType
  >;
  owner?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  isShared?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  sharedRootSurface?: Resolver<
    Maybe<ResolversTypes['SubSurfaceNode']>,
    ParentType,
    ContextType
  >;
  slug?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  position?: Resolver<
    Maybe<ResolversTypes['Position']>,
    ParentType,
    ContextType
  >;
  sharedSurfacesRoot?: Resolver<
    ResolversTypes['Boolean'],
    ParentType,
    ContextType
  >;
  mySurfacesRoot?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  rootSurface?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  pointsTo?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['SurfaceNodePointsTo']>>>,
    ParentType,
    ContextType
  >;
  originalNode?: Resolver<
    Maybe<ResolversTypes['SurfaceNodeUnion']>,
    ParentType,
    ContextType
  >;
  isOriginal?: Resolver<
    Maybe<ResolversTypes['Boolean']>,
    ParentType,
    ContextType
  >;
  isReference?: Resolver<
    Maybe<ResolversTypes['Boolean']>,
    ParentType,
    ContextType
  >;
  references?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['SurfaceNodeUnion']>>>,
    ParentType,
    ContextType
  >;
  subSurfaces?: Resolver<
    Maybe<ResolversTypes['SubSurfaceNodeListPayload']>,
    ParentType,
    ContextType
  >;
  hasReferences?: Resolver<
    Maybe<ResolversTypes['Boolean']>,
    ParentType,
    ContextType
  >;
  hasSubSurfaces?: Resolver<
    Maybe<ResolversTypes['Boolean']>,
    ParentType,
    ContextType
  >;
  subSurfacesCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['SurfaceNodeType'], ParentType, ContextType>;
  hierarchy?: Resolver<
    Array<Maybe<ResolversTypes['SubSurfaceNode']>>,
    ParentType,
    ContextType
  >;
  createdBy?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<
    Maybe<ResolversTypes['DateTime']>,
    ParentType,
    ContextType
  >;
  updatedAt?: Resolver<
    Maybe<ResolversTypes['DateTime']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SubSurfaceNodeEdgeResolvers<
  ContextType = IContext,
  ParentType extends ResolversParentTypes['SubSurfaceNodeEdge'] = ResolversParentTypes['SubSurfaceNodeEdge']
> = {
  node?: Resolver<
    Maybe<ResolversTypes['SubSurfaceNode']>,
    ParentType,
    ContextType
  >;
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SubSurfaceNodeListPayloadResolvers<
  ContextType = IContext,
  ParentType extends ResolversParentTypes['SubSurfaceNodeListPayload'] = ResolversParentTypes['SubSurfaceNodeListPayload']
> = {
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  edges?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['SubSurfaceNodeEdge']>>>,
    ParentType,
    ContextType
  >;
  meta?: Resolver<
    Maybe<ResolversTypes['ListPayloadMeta']>,
    ParentType,
    ContextType
  >;
  error?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  nodes?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['SubSurfaceNode']>>>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SubSurfaceNodePayloadResolvers<
  ContextType = IContext,
  ParentType extends ResolversParentTypes['SubSurfaceNodePayload'] = ResolversParentTypes['SubSurfaceNodePayload']
> = {
  data?: Resolver<
    Maybe<ResolversTypes['SubSurfaceNode']>,
    ParentType,
    ContextType
  >;
  error?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  success?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SurfaceResolvers<
  ContextType = IContext,
  ParentType extends ResolversParentTypes['Surface'] = ResolversParentTypes['Surface']
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  slug?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  nodes?: Resolver<
    Maybe<Array<ResolversTypes['SurfaceNodeUnion']>>,
    ParentType,
    ContextType
  >;
  hierarchy?: Resolver<
    Array<Maybe<ResolversTypes['SubSurfaceNode']>>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SurfaceContainerNodeUnionResolvers<
  ContextType = IContext,
  ParentType extends ResolversParentTypes['SurfaceContainerNodeUnion'] = ResolversParentTypes['SurfaceContainerNodeUnion']
> = {
  __resolveType: TypeResolveFn<
    'SurfaceTextNode' | 'SurfaceNoteNode' | 'SurfaceDocumentNode',
    ParentType,
    ContextType
  >;
};

export type SurfaceDocumentNodeResolvers<
  ContextType = IContext,
  ParentType extends ResolversParentTypes['SurfaceDocumentNode'] = ResolversParentTypes['SurfaceDocumentNode']
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  surface?: Resolver<
    Maybe<ResolversTypes['SubSurfaceNode']>,
    ParentType,
    ContextType
  >;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  slug?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  format?: Resolver<
    ResolversTypes['SurfaceDocumentNodeFormat'],
    ParentType,
    ContextType
  >;
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  snippets?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['SurfaceDocumentNodeSnippet']>>>,
    ParentType,
    ContextType
  >;
  instantJSON?: Resolver<
    Maybe<ResolversTypes['JSON']>,
    ParentType,
    ContextType
  >;
  position?: Resolver<
    Maybe<ResolversTypes['Position']>,
    ParentType,
    ContextType
  >;
  pointsTo?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['SurfaceNodePointsTo']>>>,
    ParentType,
    ContextType
  >;
  originalNode?: Resolver<
    Maybe<ResolversTypes['SurfaceNodeUnion']>,
    ParentType,
    ContextType
  >;
  isOriginal?: Resolver<
    Maybe<ResolversTypes['Boolean']>,
    ParentType,
    ContextType
  >;
  isReference?: Resolver<
    Maybe<ResolversTypes['Boolean']>,
    ParentType,
    ContextType
  >;
  references?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['SurfaceNodeUnion']>>>,
    ParentType,
    ContextType
  >;
  hasReferences?: Resolver<
    Maybe<ResolversTypes['Boolean']>,
    ParentType,
    ContextType
  >;
  type?: Resolver<ResolversTypes['SurfaceNodeType'], ParentType, ContextType>;
  fromRis?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  createdBy?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<
    Maybe<ResolversTypes['DateTime']>,
    ParentType,
    ContextType
  >;
  updatedAt?: Resolver<
    Maybe<ResolversTypes['DateTime']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SurfaceDocumentNodeSnippetResolvers<
  ContextType = IContext,
  ParentType extends ResolversParentTypes['SurfaceDocumentNodeSnippet'] = ResolversParentTypes['SurfaceDocumentNodeSnippet']
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  surface?: Resolver<
    Maybe<ResolversTypes['SubSurfaceNode']>,
    ParentType,
    ContextType
  >;
  containerNode?: Resolver<
    Maybe<ResolversTypes['SurfaceContainerNodeUnion']>,
    ParentType,
    ContextType
  >;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  slug?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  text?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  annotationId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  position?: Resolver<
    Maybe<ResolversTypes['Position']>,
    ParentType,
    ContextType
  >;
  pointsTo?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['SurfaceNodePointsTo']>>>,
    ParentType,
    ContextType
  >;
  originalNode?: Resolver<
    Maybe<ResolversTypes['SurfaceNodeUnion']>,
    ParentType,
    ContextType
  >;
  isOriginal?: Resolver<
    Maybe<ResolversTypes['Boolean']>,
    ParentType,
    ContextType
  >;
  isReference?: Resolver<
    Maybe<ResolversTypes['Boolean']>,
    ParentType,
    ContextType
  >;
  references?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['SurfaceNodeUnion']>>>,
    ParentType,
    ContextType
  >;
  hasReferences?: Resolver<
    Maybe<ResolversTypes['Boolean']>,
    ParentType,
    ContextType
  >;
  type?: Resolver<ResolversTypes['SurfaceNodeType'], ParentType, ContextType>;
  fromRis?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  createdBy?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<
    Maybe<ResolversTypes['DateTime']>,
    ParentType,
    ContextType
  >;
  updatedAt?: Resolver<
    Maybe<ResolversTypes['DateTime']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SurfaceDocumentNodeSnippetPayloadResolvers<
  ContextType = IContext,
  ParentType extends ResolversParentTypes['SurfaceDocumentNodeSnippetPayload'] = ResolversParentTypes['SurfaceDocumentNodeSnippetPayload']
> = {
  data?: Resolver<
    Maybe<ResolversTypes['SurfaceDocumentNodeSnippet']>,
    ParentType,
    ContextType
  >;
  error?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  success?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SurfaceHierarchyPayloadResolvers<
  ContextType = IContext,
  ParentType extends ResolversParentTypes['SurfaceHierarchyPayload'] = ResolversParentTypes['SurfaceHierarchyPayload']
> = {
  data?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['SubSurfaceNode']>>>,
    ParentType,
    ContextType
  >;
  error?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  success?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SurfaceImageNodeResolvers<
  ContextType = IContext,
  ParentType extends ResolversParentTypes['SurfaceImageNode'] = ResolversParentTypes['SurfaceImageNode']
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  surface?: Resolver<
    Maybe<ResolversTypes['SubSurfaceNode']>,
    ParentType,
    ContextType
  >;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  slug?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  format?: Resolver<
    ResolversTypes['SurfaceImageNodeFormat'],
    ParentType,
    ContextType
  >;
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  position?: Resolver<
    Maybe<ResolversTypes['Position']>,
    ParentType,
    ContextType
  >;
  pointsTo?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['SurfaceNodePointsTo']>>>,
    ParentType,
    ContextType
  >;
  originalNode?: Resolver<
    Maybe<ResolversTypes['SurfaceNodeUnion']>,
    ParentType,
    ContextType
  >;
  isOriginal?: Resolver<
    Maybe<ResolversTypes['Boolean']>,
    ParentType,
    ContextType
  >;
  isReference?: Resolver<
    Maybe<ResolversTypes['Boolean']>,
    ParentType,
    ContextType
  >;
  references?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['SurfaceNodeUnion']>>>,
    ParentType,
    ContextType
  >;
  hasReferences?: Resolver<
    Maybe<ResolversTypes['Boolean']>,
    ParentType,
    ContextType
  >;
  type?: Resolver<ResolversTypes['SurfaceNodeType'], ParentType, ContextType>;
  createdBy?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<
    Maybe<ResolversTypes['DateTime']>,
    ParentType,
    ContextType
  >;
  updatedAt?: Resolver<
    Maybe<ResolversTypes['DateTime']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SurfaceNodeResolvers<
  ContextType = IContext,
  ParentType extends ResolversParentTypes['SurfaceNode'] = ResolversParentTypes['SurfaceNode']
> = {
  __resolveType: TypeResolveFn<
    | 'SubSurfaceNode'
    | 'SurfaceTextNode'
    | 'SurfaceTextNodeSnippet'
    | 'SurfaceNoteNode'
    | 'SurfaceDocumentNode'
    | 'SurfaceDocumentNodeSnippet'
    | 'SurfaceImageNode'
    | 'SurfaceProtocolNode'
    | 'SurfaceQuestionnaireNode',
    ParentType,
    ContextType
  >;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  surface?: Resolver<
    Maybe<ResolversTypes['SubSurfaceNode']>,
    ParentType,
    ContextType
  >;
  position?: Resolver<
    Maybe<ResolversTypes['Position']>,
    ParentType,
    ContextType
  >;
  pointsTo?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['SurfaceNodePointsTo']>>>,
    ParentType,
    ContextType
  >;
  originalNode?: Resolver<
    Maybe<ResolversTypes['SurfaceNodeUnion']>,
    ParentType,
    ContextType
  >;
  isOriginal?: Resolver<
    Maybe<ResolversTypes['Boolean']>,
    ParentType,
    ContextType
  >;
  isReference?: Resolver<
    Maybe<ResolversTypes['Boolean']>,
    ParentType,
    ContextType
  >;
  references?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['SurfaceNodeUnion']>>>,
    ParentType,
    ContextType
  >;
  hasReferences?: Resolver<
    Maybe<ResolversTypes['Boolean']>,
    ParentType,
    ContextType
  >;
  type?: Resolver<ResolversTypes['SurfaceNodeType'], ParentType, ContextType>;
  createdBy?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<
    Maybe<ResolversTypes['DateTime']>,
    ParentType,
    ContextType
  >;
  updatedAt?: Resolver<
    Maybe<ResolversTypes['DateTime']>,
    ParentType,
    ContextType
  >;
};

export type SurfaceNodeLinkSettingsResolvers<
  ContextType = IContext,
  ParentType extends ResolversParentTypes['SurfaceNodeLinkSettings'] = ResolversParentTypes['SurfaceNodeLinkSettings']
> = {
  color?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  startShape?: Resolver<
    Maybe<ResolversTypes['LineShape']>,
    ParentType,
    ContextType
  >;
  endShape?: Resolver<
    Maybe<ResolversTypes['LineShape']>,
    ParentType,
    ContextType
  >;
  linkType?: Resolver<
    Maybe<ResolversTypes['LinkType']>,
    ParentType,
    ContextType
  >;
  linkName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  ownedBy?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  isEditable?: Resolver<
    Maybe<ResolversTypes['Boolean']>,
    ParentType,
    ContextType
  >;
  isVisible?: Resolver<
    Maybe<ResolversTypes['Boolean']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SurfaceNodeLinkSettingsPayloadResolvers<
  ContextType = IContext,
  ParentType extends ResolversParentTypes['SurfaceNodeLinkSettingsPayload'] = ResolversParentTypes['SurfaceNodeLinkSettingsPayload']
> = {
  data?: Resolver<
    Maybe<ResolversTypes['SurfaceNodeLinkSettings']>,
    ParentType,
    ContextType
  >;
  error?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  success?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SurfaceNodeMovedResolvers<
  ContextType = IContext,
  ParentType extends ResolversParentTypes['SurfaceNodeMoved'] = ResolversParentTypes['SurfaceNodeMoved']
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  position?: Resolver<ResolversTypes['Position'], ParentType, ContextType>;
  surface?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  user?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SurfaceNodePointsToResolvers<
  ContextType = IContext,
  ParentType extends ResolversParentTypes['SurfaceNodePointsTo'] = ResolversParentTypes['SurfaceNodePointsTo']
> = {
  from?: Resolver<ResolversTypes['SurfaceNodeUnion'], ParentType, ContextType>;
  to?: Resolver<ResolversTypes['SurfaceNodeUnion'], ParentType, ContextType>;
  settings?: Resolver<
    Maybe<ResolversTypes['SurfaceNodeLinkSettings']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SurfaceNodeUnionResolvers<
  ContextType = IContext,
  ParentType extends ResolversParentTypes['SurfaceNodeUnion'] = ResolversParentTypes['SurfaceNodeUnion']
> = {
  __resolveType: TypeResolveFn<
    | 'SurfaceTextNode'
    | 'SurfaceDocumentNode'
    | 'SurfaceImageNode'
    | 'SurfaceNoteNode'
    | 'SurfaceProtocolNode'
    | 'SubSurfaceNode'
    | 'SurfaceQuestionnaireNode'
    | 'SurfaceTextNodeSnippet'
    | 'SurfaceDocumentNodeSnippet',
    ParentType,
    ContextType
  >;
};

export type SurfaceNodeUnionEdgeResolvers<
  ContextType = IContext,
  ParentType extends ResolversParentTypes['SurfaceNodeUnionEdge'] = ResolversParentTypes['SurfaceNodeUnionEdge']
> = {
  node?: Resolver<
    Maybe<ResolversTypes['SurfaceNodeUnion']>,
    ParentType,
    ContextType
  >;
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SurfaceNodeUnionListPayloadResolvers<
  ContextType = IContext,
  ParentType extends ResolversParentTypes['SurfaceNodeUnionListPayload'] = ResolversParentTypes['SurfaceNodeUnionListPayload']
> = {
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  edges?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['SurfaceNodeUnionEdge']>>>,
    ParentType,
    ContextType
  >;
  meta?: Resolver<
    Maybe<ResolversTypes['ListPayloadMeta']>,
    ParentType,
    ContextType
  >;
  error?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  nodes?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['SurfaceNodeUnion']>>>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SurfaceNodeUnionPayloadResolvers<
  ContextType = IContext,
  ParentType extends ResolversParentTypes['SurfaceNodeUnionPayload'] = ResolversParentTypes['SurfaceNodeUnionPayload']
> = {
  data?: Resolver<
    Maybe<ResolversTypes['SurfaceNodeUnion']>,
    ParentType,
    ContextType
  >;
  error?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  success?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SurfaceNoteNodeResolvers<
  ContextType = IContext,
  ParentType extends ResolversParentTypes['SurfaceNoteNode'] = ResolversParentTypes['SurfaceNoteNode']
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  surface?: Resolver<
    Maybe<ResolversTypes['SubSurfaceNode']>,
    ParentType,
    ContextType
  >;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  slug?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  text?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  slateData?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  snippets?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['SurfaceTextNodeSnippet']>>>,
    ParentType,
    ContextType
  >;
  position?: Resolver<
    Maybe<ResolversTypes['Position']>,
    ParentType,
    ContextType
  >;
  pointsTo?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['SurfaceNodePointsTo']>>>,
    ParentType,
    ContextType
  >;
  originalNode?: Resolver<
    Maybe<ResolversTypes['SurfaceNodeUnion']>,
    ParentType,
    ContextType
  >;
  isOriginal?: Resolver<
    Maybe<ResolversTypes['Boolean']>,
    ParentType,
    ContextType
  >;
  isReference?: Resolver<
    Maybe<ResolversTypes['Boolean']>,
    ParentType,
    ContextType
  >;
  references?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['SurfaceNodeUnion']>>>,
    ParentType,
    ContextType
  >;
  hasReferences?: Resolver<
    Maybe<ResolversTypes['Boolean']>,
    ParentType,
    ContextType
  >;
  type?: Resolver<ResolversTypes['SurfaceNodeType'], ParentType, ContextType>;
  createdBy?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<
    Maybe<ResolversTypes['DateTime']>,
    ParentType,
    ContextType
  >;
  updatedAt?: Resolver<
    Maybe<ResolversTypes['DateTime']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SurfaceProtocolContainingNodeUnionResolvers<
  ContextType = IContext,
  ParentType extends ResolversParentTypes['SurfaceProtocolContainingNodeUnion'] = ResolversParentTypes['SurfaceProtocolContainingNodeUnion']
> = {
  __resolveType: TypeResolveFn<
    | 'SurfaceTextNode'
    | 'SurfaceDocumentNode'
    | 'SurfaceImageNode'
    | 'SurfaceNoteNode'
    | 'SubSurfaceNode'
    | 'SurfaceQuestionnaireNode'
    | 'SurfaceTextNodeSnippet'
    | 'SurfaceDocumentNodeSnippet',
    ParentType,
    ContextType
  >;
};

export type SurfaceProtocolNodeResolvers<
  ContextType = IContext,
  ParentType extends ResolversParentTypes['SurfaceProtocolNode'] = ResolversParentTypes['SurfaceProtocolNode']
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  surface?: Resolver<
    Maybe<ResolversTypes['SubSurfaceNode']>,
    ParentType,
    ContextType
  >;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['SurfaceNodeType'], ParentType, ContextType>;
  position?: Resolver<
    Maybe<ResolversTypes['Position']>,
    ParentType,
    ContextType
  >;
  pointsTo?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['SurfaceNodePointsTo']>>>,
    ParentType,
    ContextType
  >;
  originalNode?: Resolver<
    Maybe<ResolversTypes['SurfaceNodeUnion']>,
    ParentType,
    ContextType
  >;
  isOriginal?: Resolver<
    Maybe<ResolversTypes['Boolean']>,
    ParentType,
    ContextType
  >;
  isReference?: Resolver<
    Maybe<ResolversTypes['Boolean']>,
    ParentType,
    ContextType
  >;
  references?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['SurfaceNodeUnion']>>>,
    ParentType,
    ContextType
  >;
  hasReferences?: Resolver<
    Maybe<ResolversTypes['Boolean']>,
    ParentType,
    ContextType
  >;
  contains?: Resolver<
    Maybe<ResolversTypes['SurfaceProtocolContainingNodeUnion']>,
    ParentType,
    ContextType
  >;
  createdBy?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<
    Maybe<ResolversTypes['DateTime']>,
    ParentType,
    ContextType
  >;
  updatedAt?: Resolver<
    Maybe<ResolversTypes['DateTime']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SurfaceQuestionnaireNodeResolvers<
  ContextType = IContext,
  ParentType extends ResolversParentTypes['SurfaceQuestionnaireNode'] = ResolversParentTypes['SurfaceQuestionnaireNode']
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  surface?: Resolver<
    Maybe<ResolversTypes['SubSurfaceNode']>,
    ParentType,
    ContextType
  >;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  slug?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  question?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  answerType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  position?: Resolver<
    Maybe<ResolversTypes['Position']>,
    ParentType,
    ContextType
  >;
  pointsTo?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['SurfaceNodePointsTo']>>>,
    ParentType,
    ContextType
  >;
  originalNode?: Resolver<
    Maybe<ResolversTypes['SurfaceNodeUnion']>,
    ParentType,
    ContextType
  >;
  isOriginal?: Resolver<
    Maybe<ResolversTypes['Boolean']>,
    ParentType,
    ContextType
  >;
  isReference?: Resolver<
    Maybe<ResolversTypes['Boolean']>,
    ParentType,
    ContextType
  >;
  references?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['SurfaceNodeUnion']>>>,
    ParentType,
    ContextType
  >;
  hasReferences?: Resolver<
    Maybe<ResolversTypes['Boolean']>,
    ParentType,
    ContextType
  >;
  type?: Resolver<ResolversTypes['SurfaceNodeType'], ParentType, ContextType>;
  createdBy?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<
    Maybe<ResolversTypes['DateTime']>,
    ParentType,
    ContextType
  >;
  updatedAt?: Resolver<
    Maybe<ResolversTypes['DateTime']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SurfaceTextNodeResolvers<
  ContextType = IContext,
  ParentType extends ResolversParentTypes['SurfaceTextNode'] = ResolversParentTypes['SurfaceTextNode']
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  surface?: Resolver<
    Maybe<ResolversTypes['SubSurfaceNode']>,
    ParentType,
    ContextType
  >;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  slug?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  text?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  slateData?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  snippets?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['SurfaceTextNodeSnippet']>>>,
    ParentType,
    ContextType
  >;
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  position?: Resolver<
    Maybe<ResolversTypes['Position']>,
    ParentType,
    ContextType
  >;
  pointsTo?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['SurfaceNodePointsTo']>>>,
    ParentType,
    ContextType
  >;
  originalNode?: Resolver<
    Maybe<ResolversTypes['SurfaceNodeUnion']>,
    ParentType,
    ContextType
  >;
  isOriginal?: Resolver<
    Maybe<ResolversTypes['Boolean']>,
    ParentType,
    ContextType
  >;
  isReference?: Resolver<
    Maybe<ResolversTypes['Boolean']>,
    ParentType,
    ContextType
  >;
  references?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['SurfaceNodeUnion']>>>,
    ParentType,
    ContextType
  >;
  hasReferences?: Resolver<
    Maybe<ResolversTypes['Boolean']>,
    ParentType,
    ContextType
  >;
  type?: Resolver<ResolversTypes['SurfaceNodeType'], ParentType, ContextType>;
  createdBy?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<
    Maybe<ResolversTypes['DateTime']>,
    ParentType,
    ContextType
  >;
  updatedAt?: Resolver<
    Maybe<ResolversTypes['DateTime']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SurfaceTextNodeSnippetResolvers<
  ContextType = IContext,
  ParentType extends ResolversParentTypes['SurfaceTextNodeSnippet'] = ResolversParentTypes['SurfaceTextNodeSnippet']
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  surface?: Resolver<
    Maybe<ResolversTypes['SubSurfaceNode']>,
    ParentType,
    ContextType
  >;
  containerNode?: Resolver<
    Maybe<ResolversTypes['SurfaceContainerNodeUnion']>,
    ParentType,
    ContextType
  >;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  slug?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  text?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  annotationId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  slateRepresentation?: Resolver<
    Maybe<ResolversTypes['JSON']>,
    ParentType,
    ContextType
  >;
  position?: Resolver<
    Maybe<ResolversTypes['Position']>,
    ParentType,
    ContextType
  >;
  pointsTo?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['SurfaceNodePointsTo']>>>,
    ParentType,
    ContextType
  >;
  originalNode?: Resolver<
    Maybe<ResolversTypes['SurfaceNodeUnion']>,
    ParentType,
    ContextType
  >;
  isOriginal?: Resolver<
    Maybe<ResolversTypes['Boolean']>,
    ParentType,
    ContextType
  >;
  isReference?: Resolver<
    Maybe<ResolversTypes['Boolean']>,
    ParentType,
    ContextType
  >;
  references?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['SurfaceNodeUnion']>>>,
    ParentType,
    ContextType
  >;
  hasReferences?: Resolver<
    Maybe<ResolversTypes['Boolean']>,
    ParentType,
    ContextType
  >;
  type?: Resolver<ResolversTypes['SurfaceNodeType'], ParentType, ContextType>;
  createdBy?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<
    Maybe<ResolversTypes['DateTime']>,
    ParentType,
    ContextType
  >;
  updatedAt?: Resolver<
    Maybe<ResolversTypes['DateTime']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SurfaceTextNodeSnippetPayloadResolvers<
  ContextType = IContext,
  ParentType extends ResolversParentTypes['SurfaceTextNodeSnippetPayload'] = ResolversParentTypes['SurfaceTextNodeSnippetPayload']
> = {
  data?: Resolver<
    Maybe<ResolversTypes['SurfaceTextNodeSnippet']>,
    ParentType,
    ContextType
  >;
  error?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  success?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface TimeScalarConfig
  extends GraphQLScalarTypeConfig<ResolversTypes['Time'], any> {
  name: 'Time';
}

export type UndefinedPayloadResolvers<
  ContextType = IContext,
  ParentType extends ResolversParentTypes['undefinedPayload'] = ResolversParentTypes['undefinedPayload']
> = {
  data?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  error?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  success?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UnLinkSurfaceNodesResultResolvers<
  ContextType = IContext,
  ParentType extends ResolversParentTypes['UnLinkSurfaceNodesResult'] = ResolversParentTypes['UnLinkSurfaceNodesResult']
> = {
  fromNodeId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  toNodeId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UnLinkSurfaceNodesResultPayloadResolvers<
  ContextType = IContext,
  ParentType extends ResolversParentTypes['UnLinkSurfaceNodesResultPayload'] = ResolversParentTypes['UnLinkSurfaceNodesResultPayload']
> = {
  data?: Resolver<
    Maybe<ResolversTypes['UnLinkSurfaceNodesResult']>,
    ParentType,
    ContextType
  >;
  error?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  success?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface UrlScalarConfig
  extends GraphQLScalarTypeConfig<ResolversTypes['URL'], any> {
  name: 'URL';
}

export type UserResolvers<
  ContextType = IContext,
  ParentType extends ResolversParentTypes['User'] = ResolversParentTypes['User']
> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  fullName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstName?: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  email?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  emailVerified?: Resolver<
    Maybe<ResolversTypes['Boolean']>,
    ParentType,
    ContextType
  >;
  avatar?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserAccessUnionResolvers<
  ContextType = IContext,
  ParentType extends ResolversParentTypes['UserAccessUnion'] = ResolversParentTypes['UserAccessUnion']
> = {
  __resolveType: TypeResolveFn<
    'UserWithRole' | 'InvitationWithRole',
    ParentType,
    ContextType
  >;
};

export type UserAccessUnionEdgeResolvers<
  ContextType = IContext,
  ParentType extends ResolversParentTypes['UserAccessUnionEdge'] = ResolversParentTypes['UserAccessUnionEdge']
> = {
  node?: Resolver<
    Maybe<ResolversTypes['UserAccessUnion']>,
    ParentType,
    ContextType
  >;
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserAccessUnionListPayloadResolvers<
  ContextType = IContext,
  ParentType extends ResolversParentTypes['UserAccessUnionListPayload'] = ResolversParentTypes['UserAccessUnionListPayload']
> = {
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  edges?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['UserAccessUnionEdge']>>>,
    ParentType,
    ContextType
  >;
  meta?: Resolver<
    Maybe<ResolversTypes['ListPayloadMeta']>,
    ParentType,
    ContextType
  >;
  error?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  nodes?: Resolver<
    Maybe<Array<Maybe<ResolversTypes['UserAccessUnion']>>>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserCurorMovedResolvers<
  ContextType = IContext,
  ParentType extends ResolversParentTypes['UserCurorMoved'] = ResolversParentTypes['UserCurorMoved']
> = {
  user?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  cursorPosition?: Resolver<
    Maybe<ResolversTypes['Position']>,
    ParentType,
    ContextType
  >;
  surface?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  color?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserEnteredSurfaceResolvers<
  ContextType = IContext,
  ParentType extends ResolversParentTypes['UserEnteredSurface'] = ResolversParentTypes['UserEnteredSurface']
> = {
  user?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  cursorPosition?: Resolver<
    Maybe<ResolversTypes['Position']>,
    ParentType,
    ContextType
  >;
  surface?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  color?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserLeftSurfaceResolvers<
  ContextType = IContext,
  ParentType extends ResolversParentTypes['UserLeftSurface'] = ResolversParentTypes['UserLeftSurface']
> = {
  user?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  cursorPosition?: Resolver<
    Maybe<ResolversTypes['Position']>,
    ParentType,
    ContextType
  >;
  surface?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserPayloadResolvers<
  ContextType = IContext,
  ParentType extends ResolversParentTypes['UserPayload'] = ResolversParentTypes['UserPayload']
> = {
  data?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  error?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  success?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  status?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserWithRoleResolvers<
  ContextType = IContext,
  ParentType extends ResolversParentTypes['UserWithRole'] = ResolversParentTypes['UserWithRole']
> = {
  user?: Resolver<ResolversTypes['User'], ParentType, ContextType>;
  role?: Resolver<ResolversTypes['SurfaceRole'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Resolvers<ContextType = IContext> = {
  CreateSurfaceNodeFileReadUrlResult?: CreateSurfaceNodeFileReadUrlResultResolvers<ContextType>;
  CreateSurfaceNodeFileReadUrlResultPayload?: CreateSurfaceNodeFileReadUrlResultPayloadResolvers<ContextType>;
  CreateSurfaceNodeFileUploadUrlResult?: CreateSurfaceNodeFileUploadUrlResultResolvers<ContextType>;
  CreateSurfaceNodeFileUploadUrlResultPayload?: CreateSurfaceNodeFileUploadUrlResultPayloadResolvers<ContextType>;
  Date?: GraphQLScalarType;
  DateTime?: GraphQLScalarType;
  DeleteSurfaceNodeRepsonse?: DeleteSurfaceNodeRepsonseResolvers<ContextType>;
  DeleteSurfaceNodeRepsonsePayload?: DeleteSurfaceNodeRepsonsePayloadResolvers<ContextType>;
  DeleteUserInvitationResponse?: DeleteUserInvitationResponseResolvers<ContextType>;
  DeleteUserInvitationResponsePayload?: DeleteUserInvitationResponsePayloadResolvers<ContextType>;
  EmailAddress?: GraphQLScalarType;
  IntPayload?: IntPayloadResolvers<ContextType>;
  Invitation?: InvitationResolvers<ContextType>;
  InvitationWithRole?: InvitationWithRoleResolvers<ContextType>;
  JSON?: GraphQLScalarType;
  LinkSurfaceNodesResult?: LinkSurfaceNodesResultResolvers<ContextType>;
  LinkSurfaceNodesResultPayload?: LinkSurfaceNodesResultPayloadResolvers<ContextType>;
  ListPayloadMeta?: ListPayloadMetaResolvers<ContextType>;
  MarkAllNotificationsAsSeenResponse?: MarkAllNotificationsAsSeenResponseResolvers<ContextType>;
  MarkAllNotificationsAsSeenResponsePayload?: MarkAllNotificationsAsSeenResponsePayloadResolvers<ContextType>;
  Mutation?: MutationResolvers<ContextType>;
  Node?: NodeResolvers<ContextType>;
  Notification?: NotificationResolvers<ContextType>;
  NotificationEdge?: NotificationEdgeResolvers<ContextType>;
  NotificationListPayload?: NotificationListPayloadResolvers<ContextType>;
  NotificationPayload?: NotificationPayloadResolvers<ContextType>;
  OffsetPageInfo?: OffsetPageInfoResolvers<ContextType>;
  PageInfo?: PageInfoResolvers<ContextType>;
  Position?: PositionResolvers<ContextType>;
  Query?: QueryResolvers<ContextType>;
  RisSearchItem?: RisSearchItemResolvers<ContextType>;
  RisSearchItemEdge?: RisSearchItemEdgeResolvers<ContextType>;
  RisSearchItemListPayload?: RisSearchItemListPayloadResolvers<ContextType>;
  SignInCode?: SignInCodeResolvers<ContextType>;
  SignInCodeEdge?: SignInCodeEdgeResolvers<ContextType>;
  SignInCodeListPayload?: SignInCodeListPayloadResolvers<ContextType>;
  SignInCodePayload?: SignInCodePayloadResolvers<ContextType>;
  SoftDeleteSurfaceNodeRepsonse?: SoftDeleteSurfaceNodeRepsonseResolvers<ContextType>;
  SoftDeleteSurfaceNodeRepsonsePayload?: SoftDeleteSurfaceNodeRepsonsePayloadResolvers<ContextType>;
  Subscription?: SubscriptionResolvers<ContextType>;
  SubSurfaceNode?: SubSurfaceNodeResolvers<ContextType>;
  SubSurfaceNodeEdge?: SubSurfaceNodeEdgeResolvers<ContextType>;
  SubSurfaceNodeListPayload?: SubSurfaceNodeListPayloadResolvers<ContextType>;
  SubSurfaceNodePayload?: SubSurfaceNodePayloadResolvers<ContextType>;
  Surface?: SurfaceResolvers<ContextType>;
  SurfaceContainerNodeUnion?: SurfaceContainerNodeUnionResolvers<ContextType>;
  SurfaceDocumentNode?: SurfaceDocumentNodeResolvers<ContextType>;
  SurfaceDocumentNodeSnippet?: SurfaceDocumentNodeSnippetResolvers<ContextType>;
  SurfaceDocumentNodeSnippetPayload?: SurfaceDocumentNodeSnippetPayloadResolvers<ContextType>;
  SurfaceHierarchyPayload?: SurfaceHierarchyPayloadResolvers<ContextType>;
  SurfaceImageNode?: SurfaceImageNodeResolvers<ContextType>;
  SurfaceNode?: SurfaceNodeResolvers<ContextType>;
  SurfaceNodeLinkSettings?: SurfaceNodeLinkSettingsResolvers<ContextType>;
  SurfaceNodeLinkSettingsPayload?: SurfaceNodeLinkSettingsPayloadResolvers<ContextType>;
  SurfaceNodeMoved?: SurfaceNodeMovedResolvers<ContextType>;
  SurfaceNodePointsTo?: SurfaceNodePointsToResolvers<ContextType>;
  SurfaceNodeUnion?: SurfaceNodeUnionResolvers<ContextType>;
  SurfaceNodeUnionEdge?: SurfaceNodeUnionEdgeResolvers<ContextType>;
  SurfaceNodeUnionListPayload?: SurfaceNodeUnionListPayloadResolvers<ContextType>;
  SurfaceNodeUnionPayload?: SurfaceNodeUnionPayloadResolvers<ContextType>;
  SurfaceNoteNode?: SurfaceNoteNodeResolvers<ContextType>;
  SurfaceProtocolContainingNodeUnion?: SurfaceProtocolContainingNodeUnionResolvers<ContextType>;
  SurfaceProtocolNode?: SurfaceProtocolNodeResolvers<ContextType>;
  SurfaceQuestionnaireNode?: SurfaceQuestionnaireNodeResolvers<ContextType>;
  SurfaceTextNode?: SurfaceTextNodeResolvers<ContextType>;
  SurfaceTextNodeSnippet?: SurfaceTextNodeSnippetResolvers<ContextType>;
  SurfaceTextNodeSnippetPayload?: SurfaceTextNodeSnippetPayloadResolvers<ContextType>;
  Time?: GraphQLScalarType;
  undefinedPayload?: UndefinedPayloadResolvers<ContextType>;
  UnLinkSurfaceNodesResult?: UnLinkSurfaceNodesResultResolvers<ContextType>;
  UnLinkSurfaceNodesResultPayload?: UnLinkSurfaceNodesResultPayloadResolvers<ContextType>;
  URL?: GraphQLScalarType;
  User?: UserResolvers<ContextType>;
  UserAccessUnion?: UserAccessUnionResolvers<ContextType>;
  UserAccessUnionEdge?: UserAccessUnionEdgeResolvers<ContextType>;
  UserAccessUnionListPayload?: UserAccessUnionListPayloadResolvers<ContextType>;
  UserCurorMoved?: UserCurorMovedResolvers<ContextType>;
  UserEnteredSurface?: UserEnteredSurfaceResolvers<ContextType>;
  UserLeftSurface?: UserLeftSurfaceResolvers<ContextType>;
  UserPayload?: UserPayloadResolvers<ContextType>;
  UserWithRole?: UserWithRoleResolvers<ContextType>;
};

/**
 * @deprecated
 * Use "Resolvers" root object instead. If you wish to get "IResolvers", add "typesPrefix: I" to your config.
 */
export type IResolvers<ContextType = IContext> = Resolvers<ContextType>;
